/**
 * Gecontroleerde routegegevens per plaats: echte autoroute-afstand (km) en
 * rijtijd (minuten) volgens de Google Routes API (travelMode DRIVE,
 * TRAFFIC_UNAWARE), opgehaald op 2026-08-28. Dit is de enige bron van waarheid
 * voor kilometers en rijtijden op de stads-, gemeente- en prijzenpaginas.
 * Regenereren gebeurt via een Routes-API batch; niet handmatig aanpassen.
 */

export type RouteFact = { km: number; min: number };

export const ROUTE_FACTS: Record<string, Partial<Record<string, RouteFact>>> = {
  "aarlanderveen": {
    "amsterdam": { km: 48, min: 48 },
    "amsterdam-centraal": { km: 45, min: 42 },
    "brussels-airport": { km: 175, min: 124 },
    "den-haag": { km: 38, min: 38 },
    "den-haag-centraal": { km: 36, min: 33 },
    "dusseldorf-airport": { km: 233, min: 152 },
    "eindhoven-airport": { km: 144, min: 100 },
    "rotterdam": { km: 43, min: 42 },
    "rotterdam-centraal": { km: 42, min: 40 },
    "rotterdam-the-hague-airport": { km: 47, min: 35 },
    "schiphol": { km: 28, min: 27 },
    "utrecht": { km: 46, min: 42 },
    "utrecht-centraal": { km: 42, min: 35 },
  },
  "abbenbroek": {
    "amsterdam": { km: 102, min: 83 },
    "amsterdam-centraal": { km: 99, min: 77 },
    "brussels-airport": { km: 163, min: 118 },
    "den-haag": { km: 49, min: 47 },
    "den-haag-centraal": { km: 45, min: 42 },
    "dusseldorf-airport": { km: 241, min: 168 },
    "eindhoven-airport": { km: 132, min: 97 },
    "rotterdam": { km: 34, min: 36 },
    "rotterdam-centraal": { km: 33, min: 34 },
    "rotterdam-the-hague-airport": { km: 35, min: 29 },
    "schiphol": { km: 81, min: 62 },
    "utrecht": { km: 90, min: 73 },
    "utrecht-centraal": { km: 86, min: 66 },
  },
  "achthuizen": {
    "amsterdam": { km: 124, min: 92 },
    "amsterdam-centraal": { km: 121, min: 86 },
    "brussels-airport": { km: 123, min: 88 },
    "den-haag": { km: 72, min: 56 },
    "den-haag-centraal": { km: 67, min: 51 },
    "dusseldorf-airport": { km: 231, min: 155 },
    "eindhoven-airport": { km: 114, min: 81 },
    "rotterdam": { km: 40, min: 43 },
    "rotterdam-centraal": { km: 41, min: 42 },
    "rotterdam-the-hague-airport": { km: 56, min: 39 },
    "schiphol": { km: 104, min: 72 },
    "utrecht": { km: 99, min: 74 },
    "utrecht-centraal": { km: 95, min: 67 },
  },
  "alblasserdam": {
    "amsterdam": { km: 95, min: 76 },
    "amsterdam-centraal": { km: 99, min: 75 },
    "brussels-airport": { km: 137, min: 99 },
    "den-haag": { km: 49, min: 45 },
    "den-haag-centraal": { km: 45, min: 40 },
    "dusseldorf-airport": { km: 204, min: 138 },
    "eindhoven-airport": { km: 100, min: 73 },
    "rotterdam": { km: 20, min: 28 },
    "rotterdam-centraal": { km: 27, min: 30 },
    "rotterdam-the-hague-airport": { km: 29, min: 25 },
    "schiphol": { km: 81, min: 60 },
    "utrecht": { km: 62, min: 52 },
    "utrecht-centraal": { km: 59, min: 48 },
  },
  "alkmaar": {
    "amsterdam": { km: 43, min: 45 },
    "amsterdam-centraal": { km: 39, min: 41 },
    "brussels-airport": { km: 244, min: 165 },
    "den-haag": { km: 86, min: 66 },
    "den-haag-centraal": { km: 84, min: 62 },
    "dusseldorf-airport": { km: 269, min: 180 },
    "eindhoven-airport": { km: 192, min: 131 },
    "rotterdam": { km: 100, min: 75 },
    "rotterdam-centraal": { km: 100, min: 73 },
    "rotterdam-the-hague-airport": { km: 95, min: 64 },
    "schiphol": { km: 46, min: 37 },
    "utrecht": { km: 94, min: 73 },
    "utrecht-centraal": { km: 86, min: 64 },
  },
  "alphen-aan-den-rijn": {
    "amsterdam": { km: 45, min: 48 },
    "amsterdam-centraal": { km: 42, min: 43 },
    "brussels-airport": { km: 174, min: 124 },
    "den-haag": { km: 31, min: 32 },
    "den-haag-centraal": { km: 28, min: 28 },
    "dusseldorf-airport": { km: 232, min: 151 },
    "eindhoven-airport": { km: 143, min: 99 },
    "rotterdam": { km: 45, min: 41 },
    "rotterdam-centraal": { km: 44, min: 39 },
    "rotterdam-the-hague-airport": { km: 40, min: 30 },
    "schiphol": { km: 25, min: 28 },
    "utrecht": { km: 44, min: 41 },
    "utrecht-centraal": { km: 40, min: 34 },
  },
  "amersfoort": {
    "amsterdam": { km: 50, min: 49 },
    "amsterdam-centraal": { km: 50, min: 49 },
    "brussels-airport": { km: 186, min: 132 },
    "den-haag": { km: 88, min: 68 },
    "den-haag-centraal": { km: 85, min: 63 },
    "dusseldorf-airport": { km: 189, min: 129 },
    "eindhoven-airport": { km: 132, min: 94 },
    "rotterdam": { km: 82, min: 67 },
    "rotterdam-centraal": { km: 82, min: 65 },
    "rotterdam-the-hague-airport": { km: 84, min: 59 },
    "schiphol": { km: 61, min: 49 },
    "utrecht": { km: 24, min: 28 },
    "utrecht-centraal": { km: 28, min: 31 },
  },
  "ammerstol": {
    "amsterdam": { km: 71, min: 68 },
    "amsterdam-centraal": { km: 79, min: 69 },
    "brussels-airport": { km: 172, min: 127 },
    "den-haag": { km: 48, min: 49 },
    "den-haag-centraal": { km: 45, min: 44 },
    "dusseldorf-airport": { km: 227, min: 157 },
    "eindhoven-airport": { km: 128, min: 98 },
    "rotterdam": { km: 39, min: 45 },
    "rotterdam-centraal": { km: 38, min: 43 },
    "rotterdam-the-hague-airport": { km: 40, min: 37 },
    "schiphol": { km: 58, min: 62 },
    "utrecht": { km: 39, min: 46 },
    "utrecht-centraal": { km: 35, min: 39 },
  },
  "amstelveen": {
    "amsterdam": { km: 14, min: 26 },
    "amsterdam-centraal": { km: 16, min: 26 },
    "brussels-airport": { km: 198, min: 140 },
    "den-haag": { km: 56, min: 47 },
    "den-haag-centraal": { km: 54, min: 42 },
    "dusseldorf-airport": { km: 233, min: 154 },
    "eindhoven-airport": { km: 144, min: 102 },
    "rotterdam": { km: 71, min: 55 },
    "rotterdam-centraal": { km: 70, min: 53 },
    "rotterdam-the-hague-airport": { km: 65, min: 44 },
    "schiphol": { km: 14, min: 16 },
    "utrecht": { km: 46, min: 44 },
    "utrecht-centraal": { km: 38, min: 35 },
  },
  "amsterdam": {
    "amsterdam-centraal": { km: 4, min: 12 },
    "brussels-airport": { km: 204, min: 151 },
    "den-haag": { km: 65, min: 63 },
    "den-haag-centraal": { km: 62, min: 58 },
    "dusseldorf-airport": { km: 233, min: 159 },
    "eindhoven-airport": { km: 150, min: 113 },
    "rotterdam": { km: 79, min: 71 },
    "rotterdam-centraal": { km: 78, min: 69 },
    "rotterdam-the-hague-airport": { km: 74, min: 60 },
    "schiphol": { km: 22, min: 32 },
    "utrecht": { km: 53, min: 52 },
    "utrecht-centraal": { km: 44, min: 47 },
  },
  "arkel": {
    "amsterdam": { km: 71, min: 61 },
    "amsterdam-centraal": { km: 79, min: 63 },
    "brussels-airport": { km: 140, min: 101 },
    "den-haag": { km: 76, min: 64 },
    "den-haag-centraal": { km: 72, min: 59 },
    "dusseldorf-airport": { km: 181, min: 124 },
    "eindhoven-airport": { km: 78, min: 58 },
    "rotterdam": { km: 47, min: 47 },
    "rotterdam-centraal": { km: 54, min: 50 },
    "rotterdam-the-hague-airport": { km: 57, min: 44 },
    "schiphol": { km: 78, min: 59 },
    "utrecht": { km: 37, min: 37 },
    "utrecht-centraal": { km: 35, min: 33 },
  },
  "barendrecht": {
    "amsterdam": { km: 97, min: 76 },
    "amsterdam-centraal": { km: 94, min: 71 },
    "brussels-airport": { km: 135, min: 97 },
    "den-haag": { km: 45, min: 41 },
    "den-haag-centraal": { km: 39, min: 36 },
    "dusseldorf-airport": { km: 213, min: 147 },
    "eindhoven-airport": { km: 104, min: 75 },
    "rotterdam": { km: 15, min: 23 },
    "rotterdam-centraal": { km: 11, min: 27 },
    "rotterdam-the-hague-airport": { km: 24, min: 21 },
    "schiphol": { km: 77, min: 56 },
    "utrecht": { km: 67, min: 56 },
    "utrecht-centraal": { km: 63, min: 49 },
  },
  "benthuizen": {
    "amsterdam": { km: 60, min: 54 },
    "amsterdam-centraal": { km: 57, min: 49 },
    "brussels-airport": { km: 165, min: 118 },
    "den-haag": { km: 24, min: 26 },
    "den-haag-centraal": { km: 22, min: 22 },
    "dusseldorf-airport": { km: 241, min: 156 },
    "eindhoven-airport": { km: 133, min: 96 },
    "rotterdam": { km: 38, min: 35 },
    "rotterdam-centraal": { km: 37, min: 33 },
    "rotterdam-the-hague-airport": { km: 22, min: 23 },
    "schiphol": { km: 40, min: 34 },
    "utrecht": { km: 54, min: 46 },
    "utrecht-centraal": { km: 50, min: 39 },
  },
  "bergambacht": {
    "amsterdam": { km: 74, min: 73 },
    "amsterdam-centraal": { km: 71, min: 71 },
    "brussels-airport": { km: 167, min: 120 },
    "den-haag": { km: 43, min: 43 },
    "den-haag-centraal": { km: 41, min: 38 },
    "dusseldorf-airport": { km: 245, min: 162 },
    "eindhoven-airport": { km: 136, min: 99 },
    "rotterdam": { km: 35, min: 39 },
    "rotterdam-centraal": { km: 34, min: 36 },
    "rotterdam-the-hague-airport": { km: 36, min: 31 },
    "schiphol": { km: 54, min: 56 },
    "utrecht": { km: 43, min: 51 },
    "utrecht-centraal": { km: 39, min: 44 },
  },
  "bergschenhoek": {
    "amsterdam": { km: 81, min: 65 },
    "amsterdam-centraal": { km: 78, min: 60 },
    "brussels-airport": { km: 148, min: 105 },
    "den-haag": { km: 29, min: 29 },
    "den-haag-centraal": { km: 24, min: 24 },
    "dusseldorf-airport": { km: 226, min: 154 },
    "eindhoven-airport": { km: 117, min: 83 },
    "rotterdam": { km: 15, min: 21 },
    "rotterdam-centraal": { km: 14, min: 19 },
    "rotterdam-the-hague-airport": { km: 9, min: 9 },
    "schiphol": { km: 61, min: 45 },
    "utrecht": { km: 61, min: 51 },
    "utrecht-centraal": { km: 57, min: 44 },
  },
  "berkel-en-rodenrijs": {
    "amsterdam": { km: 76, min: 65 },
    "amsterdam-centraal": { km: 73, min: 60 },
    "brussels-airport": { km: 149, min: 105 },
    "den-haag": { km: 23, min: 30 },
    "den-haag-centraal": { km: 19, min: 25 },
    "dusseldorf-airport": { km: 226, min: 155 },
    "eindhoven-airport": { km: 117, min: 83 },
    "rotterdam": { km: 15, min: 21 },
    "rotterdam-centraal": { km: 14, min: 19 },
    "rotterdam-the-hague-airport": { km: 9, min: 9 },
    "schiphol": { km: 55, min: 45 },
    "utrecht": { km: 61, min: 51 },
    "utrecht-centraal": { km: 57, min: 44 },
  },
  "berkenwoude": {
    "amsterdam": { km: 88, min: 78 },
    "amsterdam-centraal": { km: 70, min: 76 },
    "brussels-airport": { km: 165, min: 125 },
    "den-haag": { km: 41, min: 47 },
    "den-haag-centraal": { km: 39, min: 42 },
    "dusseldorf-airport": { km: 243, min: 166 },
    "eindhoven-airport": { km: 134, min: 103 },
    "rotterdam": { km: 33, min: 43 },
    "rotterdam-centraal": { km: 32, min: 40 },
    "rotterdam-the-hague-airport": { km: 34, min: 35 },
    "schiphol": { km: 53, min: 62 },
    "utrecht": { km: 56, min: 56 },
    "utrecht-centraal": { km: 52, min: 49 },
  },
  "beverwijk": {
    "amsterdam": { km: 35, min: 39 },
    "amsterdam-centraal": { km: 32, min: 35 },
    "brussels-airport": { km: 224, min: 153 },
    "den-haag": { km: 66, min: 54 },
    "den-haag-centraal": { km: 64, min: 49 },
    "dusseldorf-airport": { km: 260, min: 170 },
    "eindhoven-airport": { km: 172, min: 118 },
    "rotterdam": { km: 80, min: 62 },
    "rotterdam-centraal": { km: 80, min: 60 },
    "rotterdam-the-hague-airport": { km: 75, min: 51 },
    "schiphol": { km: 26, min: 24 },
    "utrecht": { km: 74, min: 60 },
    "utrecht-centraal": { km: 66, min: 51 },
  },
  "bilthoven": {
    "amsterdam": { km: 53, min: 49 },
    "amsterdam-centraal": { km: 54, min: 49 },
    "brussels-airport": { km: 172, min: 126 },
    "den-haag": { km: 74, min: 62 },
    "den-haag-centraal": { km: 72, min: 57 },
    "dusseldorf-airport": { km: 204, min: 137 },
    "eindhoven-airport": { km: 118, min: 88 },
    "rotterdam": { km: 69, min: 60 },
    "rotterdam-centraal": { km: 68, min: 58 },
    "rotterdam-the-hague-airport": { km: 71, min: 53 },
    "schiphol": { km: 64, min: 49 },
    "utrecht": { km: 9, min: 19 },
    "utrecht-centraal": { km: 14, min: 24 },
  },
  "bleiswijk": {
    "amsterdam": { km: 73, min: 60 },
    "amsterdam-centraal": { km: 70, min: 54 },
    "brussels-airport": { km: 161, min: 115 },
    "den-haag": { km: 21, min: 24 },
    "den-haag-centraal": { km: 18, min: 19 },
    "dusseldorf-airport": { km: 238, min: 153 },
    "eindhoven-airport": { km: 129, min: 93 },
    "rotterdam": { km: 23, min: 30 },
    "rotterdam-centraal": { km: 23, min: 28 },
    "rotterdam-the-hague-airport": { km: 18, min: 18 },
    "schiphol": { km: 53, min: 40 },
    "utrecht": { km: 50, min: 43 },
    "utrecht-centraal": { km: 46, min: 36 },
  },
  "bleskensgraaf-ca": {
    "amsterdam": { km: 84, min: 72 },
    "amsterdam-centraal": { km: 91, min: 73 },
    "brussels-airport": { km: 145, min: 109 },
    "den-haag": { km: 57, min: 54 },
    "den-haag-centraal": { km: 53, min: 49 },
    "dusseldorf-airport": { km: 200, min: 138 },
    "eindhoven-airport": { km: 96, min: 72 },
    "rotterdam": { km: 28, min: 37 },
    "rotterdam-centraal": { km: 35, min: 39 },
    "rotterdam-the-hague-airport": { km: 38, min: 34 },
    "schiphol": { km: 91, min: 69 },
    "utrecht": { km: 50, min: 47 },
    "utrecht-centraal": { km: 48, min: 43 },
  },
  "bodegraven": {
    "amsterdam": { km: 56, min: 56 },
    "amsterdam-centraal": { km: 53, min: 50 },
    "brussels-airport": { km: 168, min: 119 },
    "den-haag": { km: 39, min: 38 },
    "den-haag-centraal": { km: 37, min: 33 },
    "dusseldorf-airport": { km: 225, min: 146 },
    "eindhoven-airport": { km: 136, min: 94 },
    "rotterdam": { km: 35, min: 37 },
    "rotterdam-centraal": { km: 34, min: 35 },
    "rotterdam-the-hague-airport": { km: 36, min: 29 },
    "schiphol": { km: 36, min: 36 },
    "utrecht": { km: 38, min: 36 },
    "utrecht-centraal": { km: 34, min: 30 },
  },
  "boskoop": {
    "amsterdam": { km: 54, min: 56 },
    "amsterdam-centraal": { km: 51, min: 50 },
    "brussels-airport": { km: 165, min: 118 },
    "den-haag": { km: 32, min: 37 },
    "den-haag-centraal": { km: 30, min: 32 },
    "dusseldorf-airport": { km: 228, min: 152 },
    "eindhoven-airport": { km: 133, min: 97 },
    "rotterdam": { km: 32, min: 36 },
    "rotterdam-centraal": { km: 31, min: 34 },
    "rotterdam-the-hague-airport": { km: 34, min: 29 },
    "schiphol": { km: 34, min: 36 },
    "utrecht": { km: 41, min: 43 },
    "utrecht-centraal": { km: 37, min: 36 },
  },
  "brandwijk": {
    "amsterdam": { km: 81, min: 70 },
    "amsterdam-centraal": { km: 89, min: 72 },
    "brussels-airport": { km: 146, min: 111 },
    "den-haag": { km: 62, min: 58 },
    "den-haag-centraal": { km: 58, min: 54 },
    "dusseldorf-airport": { km: 197, min: 139 },
    "eindhoven-airport": { km: 93, min: 73 },
    "rotterdam": { km: 33, min: 41 },
    "rotterdam-centraal": { km: 40, min: 44 },
    "rotterdam-the-hague-airport": { km: 43, min: 38 },
    "schiphol": { km: 88, min: 68 },
    "utrecht": { km: 47, min: 46 },
    "utrecht-centraal": { km: 45, min: 42 },
  },
  "brielle": {
    "amsterdam": { km: 96, min: 78 },
    "amsterdam-centraal": { km: 93, min: 72 },
    "brussels-airport": { km: 166, min: 119 },
    "den-haag": { km: 44, min: 42 },
    "den-haag-centraal": { km: 39, min: 37 },
    "dusseldorf-airport": { km: 244, min: 168 },
    "eindhoven-airport": { km: 134, min: 97 },
    "rotterdam": { km: 28, min: 32 },
    "rotterdam-centraal": { km: 27, min: 30 },
    "rotterdam-the-hague-airport": { km: 29, min: 25 },
    "schiphol": { km: 76, min: 57 },
    "utrecht": { km: 84, min: 69 },
    "utrecht-centraal": { km: 80, min: 62 },
  },
  "bussum": {
    "amsterdam": { km: 25, min: 31 },
    "amsterdam-centraal": { km: 26, min: 31 },
    "brussels-airport": { km: 191, min: 133 },
    "den-haag": { km: 79, min: 62 },
    "den-haag-centraal": { km: 77, min: 57 },
    "dusseldorf-airport": { km: 209, min: 135 },
    "eindhoven-airport": { km: 137, min: 95 },
    "rotterdam": { km: 88, min: 67 },
    "rotterdam-centraal": { km: 87, min: 65 },
    "rotterdam-the-hague-airport": { km: 88, min: 59 },
    "schiphol": { km: 37, min: 31 },
    "utrecht": { km: 28, min: 28 },
    "utrecht-centraal": { km: 36, min: 32 },
  },
  "capelle-aan-den-ijssel": {
    "amsterdam": { km: 85, min: 70 },
    "amsterdam-centraal": { km: 87, min: 66 },
    "brussels-airport": { km: 141, min: 100 },
    "den-haag": { km: 38, min: 36 },
    "den-haag-centraal": { km: 33, min: 31 },
    "dusseldorf-airport": { km: 219, min: 150 },
    "eindhoven-airport": { km: 109, min: 79 },
    "rotterdam": { km: 8, min: 18 },
    "rotterdam-centraal": { km: 14, min: 22 },
    "rotterdam-the-hague-airport": { km: 18, min: 16 },
    "schiphol": { km: 70, min: 51 },
    "utrecht": { km: 53, min: 48 },
    "utrecht-centraal": { km: 49, min: 41 },
  },
  "castricum": {
    "amsterdam": { km: 37, min: 41 },
    "amsterdam-centraal": { km: 34, min: 37 },
    "brussels-airport": { km: 236, min: 162 },
    "den-haag": { km: 78, min: 63 },
    "den-haag-centraal": { km: 76, min: 58 },
    "dusseldorf-airport": { km: 263, min: 176 },
    "eindhoven-airport": { km: 184, min: 127 },
    "rotterdam": { km: 93, min: 71 },
    "rotterdam-centraal": { km: 92, min: 69 },
    "rotterdam-the-hague-airport": { km: 87, min: 60 },
    "schiphol": { km: 38, min: 34 },
    "utrecht": { km: 86, min: 70 },
    "utrecht-centraal": { km: 78, min: 61 },
  },
  "cortelande": {
    "amsterdam": { km: 77, min: 62 },
    "amsterdam-centraal": { km: 76, min: 59 },
    "brussels-airport": { km: 155, min: 108 },
    "den-haag": { km: 27, min: 28 },
    "den-haag-centraal": { km: 24, min: 23 },
    "dusseldorf-airport": { km: 233, min: 150 },
    "eindhoven-airport": { km: 123, min: 86 },
    "rotterdam": { km: 22, min: 26 },
    "rotterdam-centraal": { km: 21, min: 24 },
    "rotterdam-the-hague-airport": { km: 24, min: 19 },
    "schiphol": { km: 59, min: 44 },
    "utrecht": { km: 45, min: 40 },
    "utrecht-centraal": { km: 41, min: 33 },
  },
  "dalem": {
    "amsterdam": { km: 78, min: 66 },
    "amsterdam-centraal": { km: 86, min: 67 },
    "brussels-airport": { km: 139, min: 102 },
    "den-haag": { km: 75, min: 65 },
    "den-haag-centraal": { km: 71, min: 60 },
    "dusseldorf-airport": { km: 180, min: 123 },
    "eindhoven-airport": { km: 76, min: 57 },
    "rotterdam": { km: 46, min: 48 },
    "rotterdam-centraal": { km: 53, min: 50 },
    "rotterdam-the-hague-airport": { km: 56, min: 45 },
    "schiphol": { km: 85, min: 63 },
    "utrecht": { km: 44, min: 41 },
    "utrecht-centraal": { km: 42, min: 37 },
  },
  "de-lier": {
    "amsterdam": { km: 74, min: 62 },
    "amsterdam-centraal": { km: 71, min: 57 },
    "brussels-airport": { km: 163, min: 115 },
    "den-haag": { km: 22, min: 26 },
    "den-haag-centraal": { km: 17, min: 22 },
    "dusseldorf-airport": { km: 243, min: 166 },
    "eindhoven-airport": { km: 133, min: 95 },
    "rotterdam": { km: 26, min: 28 },
    "rotterdam-centraal": { km: 25, min: 26 },
    "rotterdam-the-hague-airport": { km: 25, min: 20 },
    "schiphol": { km: 54, min: 42 },
    "utrecht": { km: 75, min: 61 },
    "utrecht-centraal": { km: 71, min: 54 },
  },
  "de-zilk": {
    "amsterdam": { km: 44, min: 46 },
    "amsterdam-centraal": { km: 41, min: 40 },
    "brussels-airport": { km: 200, min: 138 },
    "den-haag": { km: 34, min: 36 },
    "den-haag-centraal": { km: 33, min: 35 },
    "dusseldorf-airport": { km: 264, min: 175 },
    "eindhoven-airport": { km: 168, min: 117 },
    "rotterdam": { km: 56, min: 48 },
    "rotterdam-centraal": { km: 55, min: 45 },
    "rotterdam-the-hague-airport": { km: 50, min: 36 },
    "schiphol": { km: 23, min: 26 },
    "utrecht": { km: 78, min: 66 },
    "utrecht-centraal": { km: 70, min: 57 },
  },
  "delfgauw": {
    "amsterdam": { km: 69, min: 60 },
    "amsterdam-centraal": { km: 66, min: 54 },
    "brussels-airport": { km: 157, min: 114 },
    "den-haag": { km: 17, min: 24 },
    "den-haag-centraal": { km: 12, min: 19 },
    "dusseldorf-airport": { km: 235, min: 164 },
    "eindhoven-airport": { km: 125, min: 92 },
    "rotterdam": { km: 17, min: 23 },
    "rotterdam-centraal": { km: 16, min: 21 },
    "rotterdam-the-hague-airport": { km: 12, min: 12 },
    "schiphol": { km: 49, min: 40 },
    "utrecht": { km: 64, min: 58 },
    "utrecht-centraal": { km: 60, min: 51 },
  },
  "delft": {
    "amsterdam": { km: 67, min: 60 },
    "amsterdam-centraal": { km: 64, min: 54 },
    "brussels-airport": { km: 160, min: 115 },
    "den-haag": { km: 15, min: 24 },
    "den-haag-centraal": { km: 10, min: 19 },
    "dusseldorf-airport": { km: 238, min: 165 },
    "eindhoven-airport": { km: 129, min: 93 },
    "rotterdam": { km: 16, min: 25 },
    "rotterdam-centraal": { km: 15, min: 22 },
    "rotterdam-the-hague-airport": { km: 11, min: 13 },
    "schiphol": { km: 47, min: 40 },
    "utrecht": { km: 68, min: 58 },
    "utrecht-centraal": { km: 64, min: 51 },
  },
  "den-bommel": {
    "amsterdam": { km: 121, min: 89 },
    "amsterdam-centraal": { km: 118, min: 83 },
    "brussels-airport": { km: 120, min: 85 },
    "den-haag": { km: 69, min: 53 },
    "den-haag-centraal": { km: 64, min: 48 },
    "dusseldorf-airport": { km: 227, min: 152 },
    "eindhoven-airport": { km: 111, min: 78 },
    "rotterdam": { km: 37, min: 40 },
    "rotterdam-centraal": { km: 38, min: 39 },
    "rotterdam-the-hague-airport": { km: 53, min: 36 },
    "schiphol": { km: 101, min: 69 },
    "utrecht": { km: 96, min: 71 },
    "utrecht-centraal": { km: 92, min: 64 },
  },
  "den-haag": {
    "amsterdam": { km: 65, min: 60 },
    "amsterdam-centraal": { km: 62, min: 54 },
    "brussels-airport": { km: 170, min: 122 },
    "den-haag-centraal": { km: 2, min: 8 },
    "dusseldorf-airport": { km: 254, min: 168 },
    "eindhoven-airport": { km: 139, min: 101 },
    "rotterdam": { km: 27, min: 32 },
    "rotterdam-centraal": { km: 26, min: 30 },
    "rotterdam-the-hague-airport": { km: 21, min: 21 },
    "schiphol": { km: 45, min: 40 },
    "utrecht": { km: 66, min: 58 },
    "utrecht-centraal": { km: 62, min: 51 },
  },
  "den-helder": {
    "amsterdam": { km: 93, min: 79 },
    "amsterdam-centraal": { km: 90, min: 74 },
    "brussels-airport": { km: 284, min: 200 },
    "den-haag": { km: 125, min: 101 },
    "den-haag-centraal": { km: 123, min: 96 },
    "dusseldorf-airport": { km: 319, min: 214 },
    "eindhoven-airport": { km: 231, min: 165 },
    "rotterdam": { km: 140, min: 110 },
    "rotterdam-centraal": { km: 139, min: 107 },
    "rotterdam-the-hague-airport": { km: 134, min: 98 },
    "schiphol": { km: 85, min: 72 },
    "utrecht": { km: 139, min: 106 },
    "utrecht-centraal": { km: 125, min: 99 },
  },
  "den-hoorn": {
    "amsterdam": { km: 68, min: 57 },
    "amsterdam-centraal": { km: 65, min: 51 },
    "brussels-airport": { km: 159, min: 112 },
    "den-haag": { km: 16, min: 21 },
    "den-haag-centraal": { km: 11, min: 16 },
    "dusseldorf-airport": { km: 239, min: 163 },
    "eindhoven-airport": { km: 130, min: 92 },
    "rotterdam": { km: 20, min: 25 },
    "rotterdam-centraal": { km: 19, min: 23 },
    "rotterdam-the-hague-airport": { km: 18, min: 15 },
    "schiphol": { km: 48, min: 37 },
    "utrecht": { km: 69, min: 55 },
    "utrecht-centraal": { km: 65, min: 48 },
  },
  "dirksland": {
    "amsterdam": { km: 119, min: 93 },
    "amsterdam-centraal": { km: 116, min: 87 },
    "brussels-airport": { km: 138, min: 102 },
    "den-haag": { km: 66, min: 57 },
    "den-haag-centraal": { km: 62, min: 52 },
    "dusseldorf-airport": { km: 245, min: 169 },
    "eindhoven-airport": { km: 129, min: 94 },
    "rotterdam": { km: 51, min: 47 },
    "rotterdam-centraal": { km: 50, min: 45 },
    "rotterdam-the-hague-airport": { km: 51, min: 40 },
    "schiphol": { km: 99, min: 73 },
    "utrecht": { km: 107, min: 84 },
    "utrecht-centraal": { km: 103, min: 77 },
  },
  "doorn": {
    "amsterdam": { km: 65, min: 56 },
    "amsterdam-centraal": { km: 73, min: 58 },
    "brussels-airport": { km: 180, min: 128 },
    "den-haag": { km: 82, min: 63 },
    "den-haag-centraal": { km: 79, min: 58 },
    "dusseldorf-airport": { km: 183, min: 122 },
    "eindhoven-airport": { km: 125, min: 88 },
    "rotterdam": { km: 76, min: 62 },
    "rotterdam-centraal": { km: 76, min: 60 },
    "rotterdam-the-hague-airport": { km: 78, min: 54 },
    "schiphol": { km: 72, min: 54 },
    "utrecht": { km: 26, min: 29 },
    "utrecht-centraal": { km: 25, min: 27 },
  },
  "dordrecht": {
    "amsterdam": { km: 108, min: 87 },
    "amsterdam-centraal": { km: 105, min: 82 },
    "brussels-airport": { km: 127, min: 92 },
    "den-haag": { km: 55, min: 51 },
    "den-haag-centraal": { km: 51, min: 47 },
    "dusseldorf-airport": { km: 212, min: 146 },
    "eindhoven-airport": { km: 95, min: 71 },
    "rotterdam": { km: 26, min: 34 },
    "rotterdam-centraal": { km: 33, min: 37 },
    "rotterdam-the-hague-airport": { km: 35, min: 31 },
    "schiphol": { km: 87, min: 67 },
    "utrecht": { km: 78, min: 66 },
    "utrecht-centraal": { km: 74, min: 59 },
  },
  "driebruggen": {
    "amsterdam": { km: 62, min: 54 },
    "amsterdam-centraal": { km: 70, min: 56 },
    "brussels-airport": { km: 171, min: 120 },
    "den-haag": { km: 44, min: 39 },
    "den-haag-centraal": { km: 41, min: 34 },
    "dusseldorf-airport": { km: 218, min: 142 },
    "eindhoven-airport": { km: 129, min: 90 },
    "rotterdam": { km: 38, min: 38 },
    "rotterdam-centraal": { km: 38, min: 35 },
    "rotterdam-the-hague-airport": { km: 40, min: 30 },
    "schiphol": { km: 45, min: 42 },
    "utrecht": { km: 31, min: 32 },
    "utrecht-centraal": { km: 27, min: 25 },
  },
  "geervliet": {
    "amsterdam": { km: 94, min: 73 },
    "amsterdam-centraal": { km: 91, min: 67 },
    "brussels-airport": { km: 155, min: 109 },
    "den-haag": { km: 41, min: 37 },
    "den-haag-centraal": { km: 37, min: 32 },
    "dusseldorf-airport": { km: 233, min: 158 },
    "eindhoven-airport": { km: 124, min: 87 },
    "rotterdam": { km: 26, min: 28 },
    "rotterdam-centraal": { km: 25, min: 25 },
    "rotterdam-the-hague-airport": { km: 26, min: 21 },
    "schiphol": { km: 74, min: 53 },
    "utrecht": { km: 82, min: 64 },
    "utrecht-centraal": { km: 78, min: 58 },
  },
  "gelderswoude": {
    "amsterdam": { km: 54, min: 50 },
    "amsterdam-centraal": { km: 51, min: 45 },
    "brussels-airport": { km: 168, min: 123 },
    "den-haag": { km: 23, min: 30 },
    "den-haag-centraal": { km: 20, min: 25 },
    "dusseldorf-airport": { km: 244, min: 160 },
    "eindhoven-airport": { km: 136, min: 101 },
    "rotterdam": { km: 37, min: 38 },
    "rotterdam-centraal": { km: 36, min: 36 },
    "rotterdam-the-hague-airport": { km: 22, min: 26 },
    "schiphol": { km: 34, min: 30 },
    "utrecht": { km: 57, min: 50 },
    "utrecht-centraal": { km: 53, min: 43 },
  },
  "giessenburg": {
    "amsterdam": { km: 79, min: 67 },
    "amsterdam-centraal": { km: 86, min: 68 },
    "brussels-airport": { km: 137, min: 103 },
    "den-haag": { km: 66, min: 59 },
    "den-haag-centraal": { km: 61, min: 55 },
    "dusseldorf-airport": { km: 189, min: 132 },
    "eindhoven-airport": { km: 85, min: 66 },
    "rotterdam": { km: 36, min: 42 },
    "rotterdam-centraal": { km: 44, min: 45 },
    "rotterdam-the-hague-airport": { km: 46, min: 39 },
    "schiphol": { km: 86, min: 64 },
    "utrecht": { km: 45, min: 42 },
    "utrecht-centraal": { km: 43, min: 38 },
  },
  "goedereede": {
    "amsterdam": { km: 111, min: 85 },
    "amsterdam-centraal": { km: 108, min: 79 },
    "brussels-airport": { km: 148, min: 111 },
    "den-haag": { km: 58, min: 49 },
    "den-haag-centraal": { km: 54, min: 44 },
    "dusseldorf-airport": { km: 258, min: 175 },
    "eindhoven-airport": { km: 139, min: 103 },
    "rotterdam": { km: 43, min: 39 },
    "rotterdam-centraal": { km: 42, min: 37 },
    "rotterdam-the-hague-airport": { km: 43, min: 32 },
    "schiphol": { km: 91, min: 64 },
    "utrecht": { km: 99, min: 76 },
    "utrecht-centraal": { km: 95, min: 69 },
  },
  "goes": {
    "amsterdam": { km: 187, min: 130 },
    "amsterdam-centraal": { km: 184, min: 125 },
    "brussels-airport": { km: 108, min: 79 },
    "den-haag": { km: 134, min: 94 },
    "den-haag-centraal": { km: 130, min: 90 },
    "dusseldorf-airport": { km: 257, min: 172 },
    "eindhoven-airport": { km: 140, min: 97 },
    "rotterdam": { km: 103, min: 81 },
    "rotterdam-centraal": { km: 104, min: 81 },
    "rotterdam-the-hague-airport": { km: 120, min: 79 },
    "schiphol": { km: 167, min: 110 },
    "utrecht": { km: 154, min: 108 },
    "utrecht-centraal": { km: 152, min: 104 },
  },
  "gorinchem": {
    "amsterdam": { km: 76, min: 62 },
    "amsterdam-centraal": { km: 84, min: 64 },
    "brussels-airport": { km: 133, min: 97 },
    "den-haag": { km: 71, min: 61 },
    "den-haag-centraal": { km: 66, min: 56 },
    "dusseldorf-airport": { km: 180, min: 122 },
    "eindhoven-airport": { km: 76, min: 57 },
    "rotterdam": { km: 42, min: 44 },
    "rotterdam-centraal": { km: 49, min: 47 },
    "rotterdam-the-hague-airport": { km: 51, min: 41 },
    "schiphol": { km: 83, min: 60 },
    "utrecht": { km: 42, min: 38 },
    "utrecht-centraal": { km: 40, min: 34 },
  },
  "gouda": {
    "amsterdam": { km: 74, min: 64 },
    "amsterdam-centraal": { km: 60, min: 64 },
    "brussels-airport": { km: 161, min: 116 },
    "den-haag": { km: 33, min: 36 },
    "den-haag-centraal": { km: 31, min: 31 },
    "dusseldorf-airport": { km: 229, min: 152 },
    "eindhoven-airport": { km: 129, min: 95 },
    "rotterdam": { km: 28, min: 35 },
    "rotterdam-centraal": { km: 27, min: 32 },
    "rotterdam-the-hague-airport": { km: 30, min: 27 },
    "schiphol": { km: 43, min: 49 },
    "utrecht": { km: 42, min: 43 },
    "utrecht-centraal": { km: 38, min: 36 },
  },
  "gouderak": {
    "amsterdam": { km: 81, min: 69 },
    "amsterdam-centraal": { km: 64, min: 68 },
    "brussels-airport": { km: 159, min: 116 },
    "den-haag": { km: 35, min: 38 },
    "den-haag-centraal": { km: 33, min: 34 },
    "dusseldorf-airport": { km: 237, min: 157 },
    "eindhoven-airport": { km: 128, min: 94 },
    "rotterdam": { km: 26, min: 34 },
    "rotterdam-centraal": { km: 26, min: 32 },
    "rotterdam-the-hague-airport": { km: 28, min: 27 },
    "schiphol": { km: 47, min: 53 },
    "utrecht": { km: 49, min: 47 },
    "utrecht-centraal": { km: 45, min: 40 },
  },
  "goudriaan": {
    "amsterdam": { km: 72, min: 61 },
    "amsterdam-centraal": { km: 80, min: 63 },
    "brussels-airport": { km: 144, min: 105 },
    "den-haag": { km: 70, min: 64 },
    "den-haag-centraal": { km: 65, min: 59 },
    "dusseldorf-airport": { km: 194, min: 133 },
    "eindhoven-airport": { km: 91, min: 67 },
    "rotterdam": { km: 40, min: 47 },
    "rotterdam-centraal": { km: 47, min: 49 },
    "rotterdam-the-hague-airport": { km: 50, min: 44 },
    "schiphol": { km: 80, min: 59 },
    "utrecht": { km: 39, min: 37 },
    "utrecht-centraal": { km: 37, min: 33 },
  },
  "goudswaard": {
    "amsterdam": { km: 120, min: 92 },
    "amsterdam-centraal": { km: 117, min: 87 },
    "brussels-airport": { km: 130, min: 95 },
    "den-haag": { km: 67, min: 57 },
    "den-haag-centraal": { km: 63, min: 52 },
    "dusseldorf-airport": { km: 237, min: 163 },
    "eindhoven-airport": { km: 120, min: 88 },
    "rotterdam": { km: 36, min: 43 },
    "rotterdam-centraal": { km: 37, min: 43 },
    "rotterdam-the-hague-airport": { km: 52, min: 40 },
    "schiphol": { km: 100, min: 72 },
    "utrecht": { km: 94, min: 75 },
    "utrecht-centraal": { km: 90, min: 68 },
  },
  "groot-ammers": {
    "amsterdam": { km: 77, min: 66 },
    "amsterdam-centraal": { km: 85, min: 68 },
    "brussels-airport": { km: 144, min: 108 },
    "den-haag": { km: 69, min: 64 },
    "den-haag-centraal": { km: 64, min: 59 },
    "dusseldorf-airport": { km: 195, min: 136 },
    "eindhoven-airport": { km: 92, min: 70 },
    "rotterdam": { km: 39, min: 47 },
    "rotterdam-centraal": { km: 46, min: 50 },
    "rotterdam-the-hague-airport": { km: 49, min: 44 },
    "schiphol": { km: 84, min: 63 },
    "utrecht": { km: 44, min: 41 },
    "utrecht-centraal": { km: 41, min: 37 },
  },
  "haarlem": {
    "amsterdam": { km: 33, min: 40 },
    "amsterdam-centraal": { km: 21, min: 33 },
    "brussels-airport": { km: 218, min: 152 },
    "den-haag": { km: 60, min: 53 },
    "den-haag-centraal": { km: 57, min: 48 },
    "dusseldorf-airport": { km: 254, min: 169 },
    "eindhoven-airport": { km: 165, min: 117 },
    "rotterdam": { km: 74, min: 62 },
    "rotterdam-centraal": { km: 73, min: 59 },
    "rotterdam-the-hague-airport": { km: 69, min: 50 },
    "schiphol": { km: 19, min: 24 },
    "utrecht": { km: 67, min: 60 },
    "utrecht-centraal": { km: 59, min: 51 },
  },
  "haastrecht": {
    "amsterdam": { km: 65, min: 63 },
    "amsterdam-centraal": { km: 72, min: 65 },
    "brussels-airport": { km: 164, min: 121 },
    "den-haag": { km: 40, min: 43 },
    "den-haag-centraal": { km: 38, min: 38 },
    "dusseldorf-airport": { km: 220, min: 151 },
    "eindhoven-airport": { km: 128, min: 98 },
    "rotterdam": { km: 32, min: 39 },
    "rotterdam-centraal": { km: 31, min: 37 },
    "rotterdam-the-hague-airport": { km: 33, min: 31 },
    "schiphol": { km: 54, min: 52 },
    "utrecht": { km: 33, min: 42 },
    "utrecht-centraal": { km: 29, min: 35 },
  },
  "hardinxveld-giessendam": {
    "amsterdam": { km: 80, min: 68 },
    "amsterdam-centraal": { km: 88, min: 70 },
    "brussels-airport": { km: 141, min: 103 },
    "den-haag": { km: 63, min: 56 },
    "den-haag-centraal": { km: 59, min: 51 },
    "dusseldorf-airport": { km: 191, min: 130 },
    "eindhoven-airport": { km: 87, min: 64 },
    "rotterdam": { km: 34, min: 39 },
    "rotterdam-centraal": { km: 41, min: 41 },
    "rotterdam-the-hague-airport": { km: 44, min: 36 },
    "schiphol": { km: 87, min: 66 },
    "utrecht": { km: 47, min: 44 },
    "utrecht-centraal": { km: 44, min: 40 },
  },
  "hazerswoude-dorp": {
    "amsterdam": { km: 56, min: 49 },
    "amsterdam-centraal": { km: 53, min: 43 },
    "brussels-airport": { km: 179, min: 125 },
    "den-haag": { km: 28, min: 29 },
    "den-haag-centraal": { km: 26, min: 24 },
    "dusseldorf-airport": { km: 237, min: 152 },
    "eindhoven-airport": { km: 148, min: 100 },
    "rotterdam": { km: 42, min: 37 },
    "rotterdam-centraal": { km: 42, min: 35 },
    "rotterdam-the-hague-airport": { km: 37, min: 26 },
    "schiphol": { km: 35, min: 29 },
    "utrecht": { km: 49, min: 42 },
    "utrecht-centraal": { km: 45, min: 35 },
  },
  "hazerswoude-rijndijk": {
    "amsterdam": { km: 55, min: 51 },
    "amsterdam-centraal": { km: 52, min: 45 },
    "brussels-airport": { km: 179, min: 128 },
    "den-haag": { km: 27, min: 31 },
    "den-haag-centraal": { km: 25, min: 26 },
    "dusseldorf-airport": { km: 236, min: 155 },
    "eindhoven-airport": { km: 147, min: 104 },
    "rotterdam": { km: 42, min: 39 },
    "rotterdam-centraal": { km: 41, min: 37 },
    "rotterdam-the-hague-airport": { km: 36, min: 28 },
    "schiphol": { km: 35, min: 31 },
    "utrecht": { km: 49, min: 46 },
    "utrecht-centraal": { km: 45, min: 39 },
  },
  "heemskerk": {
    "amsterdam": { km: 30, min: 36 },
    "amsterdam-centraal": { km: 26, min: 31 },
    "brussels-airport": { km: 230, min: 156 },
    "den-haag": { km: 72, min: 57 },
    "den-haag-centraal": { km: 69, min: 52 },
    "dusseldorf-airport": { km: 256, min: 170 },
    "eindhoven-airport": { km: 177, min: 121 },
    "rotterdam": { km: 86, min: 65 },
    "rotterdam-centraal": { km: 85, min: 63 },
    "rotterdam-the-hague-airport": { km: 81, min: 54 },
    "schiphol": { km: 31, min: 27 },
    "utrecht": { km: 79, min: 63 },
    "utrecht-centraal": { km: 71, min: 54 },
  },
  "heenvliet": {
    "amsterdam": { km: 98, min: 78 },
    "amsterdam-centraal": { km: 94, min: 73 },
    "brussels-airport": { km: 159, min: 114 },
    "den-haag": { km: 45, min: 43 },
    "den-haag-centraal": { km: 41, min: 38 },
    "dusseldorf-airport": { km: 237, min: 164 },
    "eindhoven-airport": { km: 127, min: 93 },
    "rotterdam": { km: 29, min: 33 },
    "rotterdam-centraal": { km: 29, min: 31 },
    "rotterdam-the-hague-airport": { km: 30, min: 26 },
    "schiphol": { km: 77, min: 58 },
    "utrecht": { km: 86, min: 70 },
    "utrecht-centraal": { km: 82, min: 63 },
  },
  "heerhugowaard": {
    "amsterdam": { km: 50, min: 47 },
    "amsterdam-centraal": { km: 47, min: 43 },
    "brussels-airport": { km: 249, min: 167 },
    "den-haag": { km: 91, min: 68 },
    "den-haag-centraal": { km: 88, min: 63 },
    "dusseldorf-airport": { km: 276, min: 182 },
    "eindhoven-airport": { km: 196, min: 132 },
    "rotterdam": { km: 105, min: 76 },
    "rotterdam-centraal": { km: 104, min: 74 },
    "rotterdam-the-hague-airport": { km: 100, min: 65 },
    "schiphol": { km: 51, min: 38 },
    "utrecht": { km: 99, min: 74 },
    "utrecht-centraal": { km: 91, min: 66 },
  },
  "heerjansdam": {
    "amsterdam": { km: 99, min: 79 },
    "amsterdam-centraal": { km: 96, min: 73 },
    "brussels-airport": { km: 131, min: 95 },
    "den-haag": { km: 47, min: 43 },
    "den-haag-centraal": { km: 42, min: 38 },
    "dusseldorf-airport": { km: 216, min: 148 },
    "eindhoven-airport": { km: 99, min: 74 },
    "rotterdam": { km: 21, min: 28 },
    "rotterdam-centraal": { km: 16, min: 29 },
    "rotterdam-the-hague-airport": { km: 31, min: 26 },
    "schiphol": { km: 79, min: 59 },
    "utrecht": { km: 73, min: 61 },
    "utrecht-centraal": { km: 69, min: 54 },
  },
  "heinenoord": {
    "amsterdam": { km: 101, min: 79 },
    "amsterdam-centraal": { km: 98, min: 74 },
    "brussels-airport": { km: 131, min: 95 },
    "den-haag": { km: 49, min: 44 },
    "den-haag-centraal": { km: 44, min: 39 },
    "dusseldorf-airport": { km: 217, min: 153 },
    "eindhoven-airport": { km: 100, min: 78 },
    "rotterdam": { km: 17, min: 30 },
    "rotterdam-centraal": { km: 18, min: 30 },
    "rotterdam-the-hague-airport": { km: 33, min: 27 },
    "schiphol": { km: 81, min: 59 },
    "utrecht": { km: 76, min: 62 },
    "utrecht-centraal": { km: 72, min: 55 },
  },
  "hekelingen": {
    "amsterdam": { km: 97, min: 79 },
    "amsterdam-centraal": { km: 93, min: 74 },
    "brussels-airport": { km: 158, min: 115 },
    "den-haag": { km: 44, min: 44 },
    "den-haag-centraal": { km: 40, min: 39 },
    "dusseldorf-airport": { km: 236, min: 165 },
    "eindhoven-airport": { km: 126, min: 94 },
    "rotterdam": { km: 28, min: 34 },
    "rotterdam-centraal": { km: 28, min: 32 },
    "rotterdam-the-hague-airport": { km: 29, min: 27 },
    "schiphol": { km: 76, min: 59 },
    "utrecht": { km: 85, min: 71 },
    "utrecht-centraal": { km: 81, min: 64 },
  },
  "hellevoetsluis": {
    "amsterdam": { km: 101, min: 81 },
    "amsterdam-centraal": { km: 98, min: 76 },
    "brussels-airport": { km: 158, min: 119 },
    "den-haag": { km: 49, min: 45 },
    "den-haag-centraal": { km: 44, min: 41 },
    "dusseldorf-airport": { km: 249, min: 172 },
    "eindhoven-airport": { km: 139, min: 101 },
    "rotterdam": { km: 33, min: 36 },
    "rotterdam-centraal": { km: 32, min: 33 },
    "rotterdam-the-hague-airport": { km: 34, min: 29 },
    "schiphol": { km: 81, min: 61 },
    "utrecht": { km: 89, min: 73 },
    "utrecht-centraal": { km: 85, min: 66 },
  },
  "hendrik-ido-ambacht": {
    "amsterdam": { km: 100, min: 77 },
    "amsterdam-centraal": { km: 97, min: 71 },
    "brussels-airport": { km: 129, min: 92 },
    "den-haag": { km: 47, min: 41 },
    "den-haag-centraal": { km: 43, min: 36 },
    "dusseldorf-airport": { km: 207, min: 141 },
    "eindhoven-airport": { km: 97, min: 70 },
    "rotterdam": { km: 18, min: 23 },
    "rotterdam-centraal": { km: 25, min: 26 },
    "rotterdam-the-hague-airport": { km: 28, min: 21 },
    "schiphol": { km: 79, min: 56 },
    "utrecht": { km: 64, min: 55 },
    "utrecht-centraal": { km: 66, min: 49 },
  },
  "herkingen": {
    "amsterdam": { km: 125, min: 101 },
    "amsterdam-centraal": { km: 122, min: 95 },
    "brussels-airport": { km: 137, min: 103 },
    "den-haag": { km: 72, min: 65 },
    "den-haag-centraal": { km: 68, min: 60 },
    "dusseldorf-airport": { km: 245, min: 170 },
    "eindhoven-airport": { km: 128, min: 95 },
    "rotterdam": { km: 57, min: 55 },
    "rotterdam-centraal": { km: 56, min: 53 },
    "rotterdam-the-hague-airport": { km: 57, min: 48 },
    "schiphol": { km: 105, min: 81 },
    "utrecht": { km: 113, min: 89 },
    "utrecht-centraal": { km: 109, min: 82 },
  },
  "hillegom": {
    "amsterdam": { km: 42, min: 44 },
    "amsterdam-centraal": { km: 39, min: 39 },
    "brussels-airport": { km: 202, min: 141 },
    "den-haag": { km: 44, min: 42 },
    "den-haag-centraal": { km: 42, min: 37 },
    "dusseldorf-airport": { km: 262, min: 173 },
    "eindhoven-airport": { km: 171, min: 119 },
    "rotterdam": { km: 58, min: 51 },
    "rotterdam-centraal": { km: 58, min: 48 },
    "rotterdam-the-hague-airport": { km: 53, min: 39 },
    "schiphol": { km: 21, min: 24 },
    "utrecht": { km: 76, min: 64 },
    "utrecht-centraal": { km: 68, min: 55 },
  },
  "hilversum": {
    "amsterdam": { km: 36, min: 39 },
    "amsterdam-centraal": { km: 36, min: 39 },
    "brussels-airport": { km: 183, min: 132 },
    "den-haag": { km: 85, min: 68 },
    "den-haag-centraal": { km: 83, min: 63 },
    "dusseldorf-airport": { km: 207, min: 137 },
    "eindhoven-airport": { km: 129, min: 94 },
    "rotterdam": { km: 79, min: 66 },
    "rotterdam-centraal": { km: 79, min: 64 },
    "rotterdam-the-hague-airport": { km: 81, min: 59 },
    "schiphol": { km: 42, min: 39 },
    "utrecht": { km: 20, min: 27 },
    "utrecht-centraal": { km: 28, min: 31 },
  },
  "hoek-van-holland": {
    "amsterdam": { km: 85, min: 74 },
    "amsterdam-centraal": { km: 82, min: 69 },
    "brussels-airport": { km: 170, min: 120 },
    "den-haag": { km: 32, min: 38 },
    "den-haag-centraal": { km: 28, min: 34 },
    "dusseldorf-airport": { km: 250, min: 171 },
    "eindhoven-airport": { km: 140, min: 99 },
    "rotterdam": { km: 30, min: 32 },
    "rotterdam-centraal": { km: 30, min: 30 },
    "rotterdam-the-hague-airport": { km: 31, min: 26 },
    "schiphol": { km: 64, min: 54 },
    "utrecht": { km: 87, min: 69 },
    "utrecht-centraal": { km: 83, min: 62 },
  },
  "honselersdijk": {
    "amsterdam": { km: 78, min: 68 },
    "amsterdam-centraal": { km: 75, min: 62 },
    "brussels-airport": { km: 166, min: 117 },
    "den-haag": { km: 17, min: 33 },
    "den-haag-centraal": { km: 13, min: 28 },
    "dusseldorf-airport": { km: 246, min: 168 },
    "eindhoven-airport": { km: 137, min: 97 },
    "rotterdam": { km: 27, min: 30 },
    "rotterdam-centraal": { km: 26, min: 28 },
    "rotterdam-the-hague-airport": { km: 27, min: 23 },
    "schiphol": { km: 58, min: 48 },
    "utrecht": { km: 83, min: 67 },
    "utrecht-centraal": { km: 79, min: 60 },
  },
  "hoofddorp": {
    "amsterdam": { km: 30, min: 35 },
    "amsterdam-centraal": { km: 27, min: 30 },
    "brussels-airport": { km: 203, min: 140 },
    "den-haag": { km: 45, min: 41 },
    "den-haag-centraal": { km: 42, min: 37 },
    "dusseldorf-airport": { km: 250, min: 164 },
    "eindhoven-airport": { km: 161, min: 113 },
    "rotterdam": { km: 59, min: 50 },
    "rotterdam-centraal": { km: 58, min: 48 },
    "rotterdam-the-hague-airport": { km: 54, min: 39 },
    "schiphol": { km: 9, min: 15 },
    "utrecht": { km: 64, min: 55 },
    "utrecht-centraal": { km: 56, min: 46 },
  },
  "hoogblokland": {
    "amsterdam": { km: 68, min: 56 },
    "amsterdam-centraal": { km: 76, min: 57 },
    "brussels-airport": { km: 140, min: 100 },
    "den-haag": { km: 85, min: 63 },
    "den-haag-centraal": { km: 83, min: 58 },
    "dusseldorf-airport": { km: 190, min: 128 },
    "eindhoven-airport": { km: 86, min: 62 },
    "rotterdam": { km: 48, min: 46 },
    "rotterdam-centraal": { km: 55, min: 49 },
    "rotterdam-the-hague-airport": { km: 58, min: 43 },
    "schiphol": { km: 75, min: 53 },
    "utrecht": { km: 34, min: 31 },
    "utrecht-centraal": { km: 32, min: 27 },
  },
  "hoogmade": {
    "amsterdam": { km: 45, min: 41 },
    "amsterdam-centraal": { km: 42, min: 35 },
    "brussels-airport": { km: 184, min: 125 },
    "den-haag": { km: 26, min: 26 },
    "den-haag-centraal": { km: 24, min: 21 },
    "dusseldorf-airport": { km: 247, min: 161 },
    "eindhoven-airport": { km: 153, min: 104 },
    "rotterdam": { km: 40, min: 35 },
    "rotterdam-centraal": { km: 40, min: 32 },
    "rotterdam-the-hague-airport": { km: 35, min: 24 },
    "schiphol": { km: 25, min: 21 },
    "utrecht": { km: 60, min: 51 },
    "utrecht-centraal": { km: 56, min: 44 },
  },
  "hoogvliet-rotterdam": {
    "amsterdam": { km: 88, min: 70 },
    "amsterdam-centraal": { km: 85, min: 65 },
    "brussels-airport": { km: 147, min: 105 },
    "den-haag": { km: 35, min: 35 },
    "den-haag-centraal": { km: 31, min: 30 },
    "dusseldorf-airport": { km: 227, min: 156 },
    "eindhoven-airport": { km: 118, min: 85 },
    "rotterdam": { km: 19, min: 25 },
    "rotterdam-centraal": { km: 19, min: 23 },
    "rotterdam-the-hague-airport": { km: 20, min: 18 },
    "schiphol": { km: 67, min: 50 },
    "utrecht": { km: 76, min: 62 },
    "utrecht-centraal": { km: 72, min: 55 },
  },
  "hoorn": {
    "amsterdam": { km: 46, min: 42 },
    "amsterdam-centraal": { km: 42, min: 38 },
    "brussels-airport": { km: 245, min: 169 },
    "den-haag": { km: 97, min: 74 },
    "den-haag-centraal": { km: 95, min: 69 },
    "dusseldorf-airport": { km: 271, min: 177 },
    "eindhoven-airport": { km: 191, min: 131 },
    "rotterdam": { km: 111, min: 82 },
    "rotterdam-centraal": { km: 110, min: 80 },
    "rotterdam-the-hague-airport": { km: 106, min: 71 },
    "schiphol": { km: 54, min: 44 },
    "utrecht": { km: 91, min: 70 },
    "utrecht-centraal": { km: 86, min: 65 },
  },
  "hoornaar": {
    "amsterdam": { km: 71, min: 60 },
    "amsterdam-centraal": { km: 78, min: 61 },
    "brussels-airport": { km: 137, min: 101 },
    "den-haag": { km: 74, min: 64 },
    "den-haag-centraal": { km: 69, min: 59 },
    "dusseldorf-airport": { km: 188, min: 129 },
    "eindhoven-airport": { km: 84, min: 63 },
    "rotterdam": { km: 44, min: 47 },
    "rotterdam-centraal": { km: 51, min: 49 },
    "rotterdam-the-hague-airport": { km: 54, min: 44 },
    "schiphol": { km: 78, min: 57 },
    "utrecht": { km: 37, min: 35 },
    "utrecht-centraal": { km: 35, min: 31 },
  },
  "houten": {
    "amsterdam": { km: 50, min: 50 },
    "amsterdam-centraal": { km: 58, min: 51 },
    "brussels-airport": { km: 164, min: 119 },
    "den-haag": { km: 72, min: 57 },
    "den-haag-centraal": { km: 69, min: 52 },
    "dusseldorf-airport": { km: 199, min: 133 },
    "eindhoven-airport": { km: 110, min: 81 },
    "rotterdam": { km: 66, min: 56 },
    "rotterdam-centraal": { km: 66, min: 53 },
    "rotterdam-the-hague-airport": { km: 68, min: 48 },
    "schiphol": { km: 57, min: 47 },
    "utrecht": { km: 12, min: 22 },
    "utrecht-centraal": { km: 11, min: 20 },
  },
  "huizen": {
    "amsterdam": { km: 34, min: 37 },
    "amsterdam-centraal": { km: 34, min: 37 },
    "brussels-airport": { km: 192, min: 134 },
    "den-haag": { km: 87, min: 68 },
    "den-haag-centraal": { km: 85, min: 63 },
    "dusseldorf-airport": { km: 210, min: 138 },
    "eindhoven-airport": { km: 138, min: 96 },
    "rotterdam": { km: 88, min: 69 },
    "rotterdam-centraal": { km: 88, min: 67 },
    "rotterdam-the-hague-airport": { km: 90, min: 61 },
    "schiphol": { km: 45, min: 37 },
    "utrecht": { km: 29, min: 30 },
    "utrecht-centraal": { km: 37, min: 33 },
  },
  "hulst": {
    "amsterdam": { km: 203, min: 153 },
    "amsterdam-centraal": { km: 211, min: 155 },
    "brussels-airport": { km: 75, min: 66 },
    "den-haag": { km: 167, min: 127 },
    "den-haag-centraal": { km: 162, min: 123 },
    "dusseldorf-airport": { km: 231, min: 163 },
    "eindhoven-airport": { km: 120, min: 94 },
    "rotterdam": { km: 138, min: 110 },
    "rotterdam-centraal": { km: 145, min: 113 },
    "rotterdam-the-hague-airport": { km: 147, min: 107 },
    "schiphol": { km: 199, min: 143 },
    "utrecht": { km: 170, min: 129 },
    "utrecht-centraal": { km: 168, min: 125 },
  },
  "ijmuiden": {
    "amsterdam": { km: 40, min: 42 },
    "amsterdam-centraal": { km: 26, min: 38 },
    "brussels-airport": { km: 224, min: 154 },
    "den-haag": { km: 66, min: 55 },
    "den-haag-centraal": { km: 64, min: 51 },
    "dusseldorf-airport": { km: 261, min: 171 },
    "eindhoven-airport": { km: 172, min: 120 },
    "rotterdam": { km: 80, min: 64 },
    "rotterdam-centraal": { km: 80, min: 62 },
    "rotterdam-the-hague-airport": { km: 75, min: 53 },
    "schiphol": { km: 26, min: 26 },
    "utrecht": { km: 74, min: 62 },
    "utrecht-centraal": { km: 66, min: 53 },
  },
  "ijsselstein": {
    "amsterdam": { km: 48, min: 46 },
    "amsterdam-centraal": { km: 56, min: 48 },
    "brussels-airport": { km: 159, min: 114 },
    "den-haag": { km: 66, min: 54 },
    "den-haag-centraal": { km: 63, min: 49 },
    "dusseldorf-airport": { km: 204, min: 135 },
    "eindhoven-airport": { km: 105, min: 76 },
    "rotterdam": { km: 60, min: 52 },
    "rotterdam-centraal": { km: 59, min: 50 },
    "rotterdam-the-hague-airport": { km: 62, min: 45 },
    "schiphol": { km: 56, min: 43 },
    "utrecht": { km: 17, min: 25 },
    "utrecht-centraal": { km: 13, min: 17 },
  },
  "kaag": {
    "amsterdam": { km: 42, min: 68 },
    "amsterdam-centraal": { km: 39, min: 63 },
    "brussels-airport": { km: 195, min: 162 },
    "den-haag": { km: 37, min: 63 },
    "den-haag-centraal": { km: 34, min: 58 },
    "dusseldorf-airport": { km: 258, min: 197 },
    "eindhoven-airport": { km: 163, min: 140 },
    "rotterdam": { km: 51, min: 71 },
    "rotterdam-centraal": { km: 50, min: 69 },
    "rotterdam-the-hague-airport": { km: 46, min: 60 },
    "schiphol": { km: 22, min: 48 },
    "utrecht": { km: 71, min: 87 },
    "utrecht-centraal": { km: 69, min: 79 },
  },
  "katwijk": {
    "amsterdam": { km: 56, min: 51 },
    "amsterdam-centraal": { km: 53, min: 46 },
    "brussels-airport": { km: 187, min: 131 },
    "den-haag": { km: 21, min: 29 },
    "den-haag-centraal": { km: 20, min: 28 },
    "dusseldorf-airport": { km: 255, min: 169 },
    "eindhoven-airport": { km: 155, min: 109 },
    "rotterdam": { km: 43, min: 40 },
    "rotterdam-centraal": { km: 42, min: 38 },
    "rotterdam-the-hague-airport": { km: 38, min: 29 },
    "schiphol": { km: 35, min: 31 },
    "utrecht": { km: 68, min: 59 },
    "utrecht-centraal": { km: 64, min: 52 },
  },
  "kinderdijk": {
    "amsterdam": { km: 99, min: 83 },
    "amsterdam-centraal": { km: 103, min: 82 },
    "brussels-airport": { km: 141, min: 106 },
    "den-haag": { km: 53, min: 52 },
    "den-haag-centraal": { km: 49, min: 47 },
    "dusseldorf-airport": { km: 208, min: 145 },
    "eindhoven-airport": { km: 104, min: 80 },
    "rotterdam": { km: 24, min: 34 },
    "rotterdam-centraal": { km: 31, min: 37 },
    "rotterdam-the-hague-airport": { km: 34, min: 32 },
    "schiphol": { km: 86, min: 67 },
    "utrecht": { km: 66, min: 59 },
    "utrecht-centraal": { km: 64, min: 55 },
  },
  "klaaswaal": {
    "amsterdam": { km: 113, min: 85 },
    "amsterdam-centraal": { km: 110, min: 80 },
    "brussels-airport": { km: 123, min: 89 },
    "den-haag": { km: 61, min: 49 },
    "den-haag-centraal": { km: 56, min: 45 },
    "dusseldorf-airport": { km: 219, min: 154 },
    "eindhoven-airport": { km: 103, min: 79 },
    "rotterdam": { km: 29, min: 36 },
    "rotterdam-centraal": { km: 30, min: 36 },
    "rotterdam-the-hague-airport": { km: 45, min: 33 },
    "schiphol": { km: 93, min: 65 },
    "utrecht": { km: 87, min: 68 },
    "utrecht-centraal": { km: 83, min: 61 },
  },
  "koudekerk-aan-den-rijn": {
    "amsterdam": { km: 56, min: 53 },
    "amsterdam-centraal": { km: 53, min: 48 },
    "brussels-airport": { km: 180, min: 130 },
    "den-haag": { km: 28, min: 33 },
    "den-haag-centraal": { km: 26, min: 28 },
    "dusseldorf-airport": { km: 238, min: 158 },
    "eindhoven-airport": { km: 148, min: 106 },
    "rotterdam": { km: 43, min: 42 },
    "rotterdam-centraal": { km: 42, min: 39 },
    "rotterdam-the-hague-airport": { km: 37, min: 30 },
    "schiphol": { km: 36, min: 33 },
    "utrecht": { km: 50, min: 48 },
    "utrecht-centraal": { km: 46, min: 41 },
  },
  "krimpen-aan-de-lek": {
    "amsterdam": { km: 87, min: 84 },
    "amsterdam-centraal": { km: 94, min: 86 },
    "brussels-airport": { km: 142, min: 129 },
    "den-haag": { km: 59, min: 60 },
    "den-haag-centraal": { km: 56, min: 56 },
    "dusseldorf-airport": { km: 209, min: 168 },
    "eindhoven-airport": { km: 106, min: 102 },
    "rotterdam": { km: 25, min: 57 },
    "rotterdam-centraal": { km: 49, min: 54 },
    "rotterdam-the-hague-airport": { km: 52, min: 48 },
    "schiphol": { km: 69, min: 73 },
    "utrecht": { km: 55, min: 63 },
    "utrecht-centraal": { km: 51, min: 56 },
  },
  "krimpen-aan-den-ijssel": {
    "amsterdam": { km: 86, min: 82 },
    "amsterdam-centraal": { km: 93, min: 83 },
    "brussels-airport": { km: 147, min: 135 },
    "den-haag": { km: 47, min: 56 },
    "den-haag-centraal": { km: 45, min: 52 },
    "dusseldorf-airport": { km: 241, min: 171 },
    "eindhoven-airport": { km: 111, min: 108 },
    "rotterdam": { km: 38, min: 52 },
    "rotterdam-centraal": { km: 37, min: 50 },
    "rotterdam-the-hague-airport": { km: 40, min: 44 },
    "schiphol": { km: 59, min: 71 },
    "utrecht": { km: 54, min: 60 },
    "utrecht-centraal": { km: 50, min: 53 },
  },
  "kwintsheul": {
    "amsterdam": { km: 72, min: 68 },
    "amsterdam-centraal": { km: 69, min: 63 },
    "brussels-airport": { km: 168, min: 122 },
    "den-haag": { km: 17, min: 33 },
    "den-haag-centraal": { km: 13, min: 29 },
    "dusseldorf-airport": { km: 248, min: 173 },
    "eindhoven-airport": { km: 139, min: 101 },
    "rotterdam": { km: 29, min: 34 },
    "rotterdam-centraal": { km: 28, min: 32 },
    "rotterdam-the-hague-airport": { km: 22, min: 26 },
    "schiphol": { km: 51, min: 48 },
    "utrecht": { km: 73, min: 67 },
    "utrecht-centraal": { km: 69, min: 60 },
  },
  "langerak": {
    "amsterdam": { km: 73, min: 61 },
    "amsterdam-centraal": { km: 81, min: 62 },
    "brussels-airport": { km: 145, min: 104 },
    "den-haag": { km: 73, min: 65 },
    "den-haag-centraal": { km: 68, min: 60 },
    "dusseldorf-airport": { km: 195, min: 132 },
    "eindhoven-airport": { km: 91, min: 66 },
    "rotterdam": { km: 43, min: 48 },
    "rotterdam-centraal": { km: 50, min: 50 },
    "rotterdam-the-hague-airport": { km: 53, min: 45 },
    "schiphol": { km: 80, min: 58 },
    "utrecht": { km: 39, min: 36 },
    "utrecht-centraal": { km: 37, min: 32 },
  },
  "leerdam": {
    "amsterdam": { km: 64, min: 58 },
    "amsterdam-centraal": { km: 72, min: 60 },
    "brussels-airport": { km: 148, min: 106 },
    "den-haag": { km: 82, min: 66 },
    "den-haag-centraal": { km: 79, min: 61 },
    "dusseldorf-airport": { km: 177, min: 121 },
    "eindhoven-airport": { km: 74, min: 55 },
    "rotterdam": { km: 55, min: 52 },
    "rotterdam-centraal": { km: 62, min: 54 },
    "rotterdam-the-hague-airport": { km: 65, min: 49 },
    "schiphol": { km: 72, min: 56 },
    "utrecht": { km: 31, min: 34 },
    "utrecht-centraal": { km: 29, min: 29 },
  },
  "leiden": {
    "amsterdam": { km: 47, min: 49 },
    "amsterdam-centraal": { km: 44, min: 44 },
    "brussels-airport": { km: 179, min: 127 },
    "den-haag": { km: 21, min: 28 },
    "den-haag-centraal": { km: 19, min: 23 },
    "dusseldorf-airport": { km: 244, min: 164 },
    "eindhoven-airport": { km: 148, min: 105 },
    "rotterdam": { km: 36, min: 36 },
    "rotterdam-centraal": { km: 35, min: 34 },
    "rotterdam-the-hague-airport": { km: 30, min: 25 },
    "schiphol": { km: 27, min: 29 },
    "utrecht": { km: 57, min: 54 },
    "utrecht-centraal": { km: 53, min: 47 },
  },
  "leiderdorp": {
    "amsterdam": { km: 45, min: 42 },
    "amsterdam-centraal": { km: 42, min: 36 },
    "brussels-airport": { km: 183, min: 125 },
    "den-haag": { km: 25, min: 26 },
    "den-haag-centraal": { km: 23, min: 21 },
    "dusseldorf-airport": { km: 246, min: 161 },
    "eindhoven-airport": { km: 152, min: 104 },
    "rotterdam": { km: 39, min: 35 },
    "rotterdam-centraal": { km: 39, min: 32 },
    "rotterdam-the-hague-airport": { km: 34, min: 24 },
    "schiphol": { km: 25, min: 22 },
    "utrecht": { km: 59, min: 51 },
    "utrecht-centraal": { km: 55, min: 44 },
  },
  "leidschendam": {
    "amsterdam": { km: 61, min: 54 },
    "amsterdam-centraal": { km: 58, min: 49 },
    "brussels-airport": { km: 170, min: 119 },
    "den-haag": { km: 12, min: 20 },
    "den-haag-centraal": { km: 7, min: 15 },
    "dusseldorf-airport": { km: 253, min: 164 },
    "eindhoven-airport": { km: 138, min: 97 },
    "rotterdam": { km: 26, min: 28 },
    "rotterdam-centraal": { km: 25, min: 26 },
    "rotterdam-the-hague-airport": { km: 21, min: 17 },
    "schiphol": { km: 41, min: 34 },
    "utrecht": { km: 65, min: 54 },
    "utrecht-centraal": { km: 61, min: 47 },
  },
  "leimuiden": {
    "amsterdam": { km: 36, min: 38 },
    "amsterdam-centraal": { km: 33, min: 32 },
    "brussels-airport": { km: 197, min: 136 },
    "den-haag": { km: 39, min: 37 },
    "den-haag-centraal": { km: 37, min: 32 },
    "dusseldorf-airport": { km: 244, min: 163 },
    "eindhoven-airport": { km: 155, min: 112 },
    "rotterdam": { km: 53, min: 46 },
    "rotterdam-centraal": { km: 52, min: 43 },
    "rotterdam-the-hague-airport": { km: 48, min: 34 },
    "schiphol": { km: 15, min: 18 },
    "utrecht": { km: 57, min: 53 },
    "utrecht-centraal": { km: 53, min: 47 },
  },
  "lekkerkerk": {
    "amsterdam": { km: 81, min: 76 },
    "amsterdam-centraal": { km: 89, min: 78 },
    "brussels-airport": { km: 177, min: 130 },
    "den-haag": { km: 53, min: 52 },
    "den-haag-centraal": { km: 51, min: 47 },
    "dusseldorf-airport": { km: 237, min: 165 },
    "eindhoven-airport": { km: 137, min: 106 },
    "rotterdam": { km: 44, min: 48 },
    "rotterdam-centraal": { km: 44, min: 46 },
    "rotterdam-the-hague-airport": { km: 46, min: 40 },
    "schiphol": { km: 63, min: 65 },
    "utrecht": { km: 49, min: 55 },
    "utrecht-centraal": { km: 45, min: 48 },
  },
  "lisse": {
    "amsterdam": { km: 45, min: 43 },
    "amsterdam-centraal": { km: 42, min: 38 },
    "brussels-airport": { km: 195, min: 136 },
    "den-haag": { km: 29, min: 34 },
    "den-haag-centraal": { km: 29, min: 33 },
    "dusseldorf-airport": { km: 265, min: 173 },
    "eindhoven-airport": { km: 163, min: 114 },
    "rotterdam": { km: 51, min: 45 },
    "rotterdam-centraal": { km: 50, min: 43 },
    "rotterdam-the-hague-airport": { km: 46, min: 34 },
    "schiphol": { km: 24, min: 23 },
    "utrecht": { km: 79, min: 63 },
    "utrecht-centraal": { km: 71, min: 54 },
  },
  "maarssen": {
    "amsterdam": { km: 33, min: 38 },
    "amsterdam-centraal": { km: 41, min: 39 },
    "brussels-airport": { km: 172, min: 124 },
    "den-haag": { km: 68, min: 56 },
    "den-haag-centraal": { km: 65, min: 51 },
    "dusseldorf-airport": { km: 208, min: 138 },
    "eindhoven-airport": { km: 119, min: 86 },
    "rotterdam": { km: 62, min: 54 },
    "rotterdam-centraal": { km: 62, min: 52 },
    "rotterdam-the-hague-airport": { km: 64, min: 47 },
    "schiphol": { km: 40, min: 35 },
    "utrecht": { km: 11, min: 28 },
    "utrecht-centraal": { km: 13, min: 19 },
  },
  "maasdam": {
    "amsterdam": { km: 105, min: 82 },
    "amsterdam-centraal": { km: 102, min: 77 },
    "brussels-airport": { km: 126, min: 94 },
    "den-haag": { km: 52, min: 46 },
    "den-haag-centraal": { km: 48, min: 42 },
    "dusseldorf-airport": { km: 211, min: 147 },
    "eindhoven-airport": { km: 95, min: 73 },
    "rotterdam": { km: 21, min: 33 },
    "rotterdam-centraal": { km: 22, min: 33 },
    "rotterdam-the-hague-airport": { km: 37, min: 30 },
    "schiphol": { km: 84, min: 62 },
    "utrecht": { km: 79, min: 64 },
    "utrecht-centraal": { km: 75, min: 58 },
  },
  "maasdijk": {
    "amsterdam": { km: 80, min: 69 },
    "amsterdam-centraal": { km: 77, min: 64 },
    "brussels-airport": { km: 161, min: 113 },
    "den-haag": { km: 27, min: 34 },
    "den-haag-centraal": { km: 23, min: 29 },
    "dusseldorf-airport": { km: 241, min: 164 },
    "eindhoven-airport": { km: 132, min: 93 },
    "rotterdam": { km: 22, min: 26 },
    "rotterdam-centraal": { km: 21, min: 23 },
    "rotterdam-the-hague-airport": { km: 22, min: 19 },
    "schiphol": { km: 60, min: 49 },
    "utrecht": { km: 78, min: 63 },
    "utrecht-centraal": { km: 74, min: 56 },
  },
  "maasland": {
    "amsterdam": { km: 80, min: 72 },
    "amsterdam-centraal": { km: 77, min: 66 },
    "brussels-airport": { km: 158, min: 115 },
    "den-haag": { km: 28, min: 36 },
    "den-haag-centraal": { km: 23, min: 31 },
    "dusseldorf-airport": { km: 238, min: 166 },
    "eindhoven-airport": { km: 129, min: 94 },
    "rotterdam": { km: 19, min: 27 },
    "rotterdam-centraal": { km: 18, min: 25 },
    "rotterdam-the-hague-airport": { km: 19, min: 21 },
    "schiphol": { km: 60, min: 51 },
    "utrecht": { km: 75, min: 64 },
    "utrecht-centraal": { km: 71, min: 57 },
  },
  "maassluis": {
    "amsterdam": { km: 87, min: 70 },
    "amsterdam-centraal": { km: 84, min: 65 },
    "brussels-airport": { km: 158, min: 112 },
    "den-haag": { km: 34, min: 34 },
    "den-haag-centraal": { km: 30, min: 30 },
    "dusseldorf-airport": { km: 238, min: 163 },
    "eindhoven-airport": { km: 128, min: 91 },
    "rotterdam": { km: 18, min: 24 },
    "rotterdam-centraal": { km: 18, min: 22 },
    "rotterdam-the-hague-airport": { km: 19, min: 18 },
    "schiphol": { km: 66, min: 50 },
    "utrecht": { km: 75, min: 61 },
    "utrecht-centraal": { km: 71, min: 54 },
  },
  "melissant": {
    "amsterdam": { km: 115, min: 90 },
    "amsterdam-centraal": { km: 112, min: 85 },
    "brussels-airport": { km: 141, min: 106 },
    "den-haag": { km: 62, min: 54 },
    "den-haag-centraal": { km: 58, min: 50 },
    "dusseldorf-airport": { km: 248, min: 173 },
    "eindhoven-airport": { km: 131, min: 98 },
    "rotterdam": { km: 46, min: 44 },
    "rotterdam-centraal": { km: 46, min: 42 },
    "rotterdam-the-hague-airport": { km: 47, min: 38 },
    "schiphol": { km: 95, min: 70 },
    "utrecht": { km: 103, min: 81 },
    "utrecht-centraal": { km: 99, min: 74 },
  },
  "middelburg": {
    "amsterdam": { km: 165, min: 136 },
    "amsterdam-centraal": { km: 162, min: 131 },
    "brussels-airport": { km: 126, min: 93 },
    "den-haag": { km: 113, min: 101 },
    "den-haag-centraal": { km: 108, min: 96 },
    "dusseldorf-airport": { km: 275, min: 185 },
    "eindhoven-airport": { km: 158, min: 111 },
    "rotterdam": { km: 97, min: 91 },
    "rotterdam-centraal": { km: 96, min: 89 },
    "rotterdam-the-hague-airport": { km: 97, min: 84 },
    "schiphol": { km: 145, min: 116 },
    "utrecht": { km: 173, min: 122 },
    "utrecht-centraal": { km: 170, min: 118 },
  },
  "middelharnis": {
    "amsterdam": { km: 126, min: 100 },
    "amsterdam-centraal": { km: 123, min: 95 },
    "brussels-airport": { km: 133, min: 99 },
    "den-haag": { km: 73, min: 64 },
    "den-haag-centraal": { km: 69, min: 60 },
    "dusseldorf-airport": { km: 240, min: 166 },
    "eindhoven-airport": { km: 123, min: 91 },
    "rotterdam": { km: 58, min: 55 },
    "rotterdam-centraal": { km: 57, min: 52 },
    "rotterdam-the-hague-airport": { km: 58, min: 48 },
    "schiphol": { km: 106, min: 80 },
    "utrecht": { km: 108, min: 84 },
    "utrecht-centraal": { km: 104, min: 78 },
  },
  "mijnsheerenland": {
    "amsterdam": { km: 102, min: 79 },
    "amsterdam-centraal": { km: 99, min: 73 },
    "brussels-airport": { km: 132, min: 95 },
    "den-haag": { km: 49, min: 43 },
    "den-haag-centraal": { km: 45, min: 38 },
    "dusseldorf-airport": { km: 217, min: 153 },
    "eindhoven-airport": { km: 101, min: 79 },
    "rotterdam": { km: 18, min: 30 },
    "rotterdam-centraal": { km: 19, min: 29 },
    "rotterdam-the-hague-airport": { km: 34, min: 26 },
    "schiphol": { km: 82, min: 59 },
    "utrecht": { km: 76, min: 61 },
    "utrecht-centraal": { km: 72, min: 54 },
  },
  "moerkapelle": {
    "amsterdam": { km: 80, min: 67 },
    "amsterdam-centraal": { km: 77, min: 61 },
    "brussels-airport": { km: 159, min: 116 },
    "den-haag": { km: 28, min: 31 },
    "den-haag-centraal": { km: 26, min: 26 },
    "dusseldorf-airport": { km: 235, min: 155 },
    "eindhoven-airport": { km: 127, min: 94 },
    "rotterdam": { km: 26, min: 34 },
    "rotterdam-centraal": { km: 25, min: 32 },
    "rotterdam-the-hague-airport": { km: 28, min: 27 },
    "schiphol": { km: 60, min: 47 },
    "utrecht": { km: 48, min: 45 },
    "utrecht-centraal": { km: 44, min: 38 },
  },
  "molenaarsgraaf": {
    "amsterdam": { km: 78, min: 65 },
    "amsterdam-centraal": { km: 85, min: 67 },
    "brussels-airport": { km: 142, min: 105 },
    "den-haag": { km: 61, min: 55 },
    "den-haag-centraal": { km: 56, min: 50 },
    "dusseldorf-airport": { km: 194, min: 134 },
    "eindhoven-airport": { km: 90, min: 68 },
    "rotterdam": { km: 31, min: 37 },
    "rotterdam-centraal": { km: 38, min: 40 },
    "rotterdam-the-hague-airport": { km: 41, min: 35 },
    "schiphol": { km: 85, min: 63 },
    "utrecht": { km: 44, min: 41 },
    "utrecht-centraal": { km: 42, min: 37 },
  },
  "monster": {
    "amsterdam": { km: 78, min: 77 },
    "amsterdam-centraal": { km: 75, min: 72 },
    "brussels-airport": { km: 172, min: 125 },
    "den-haag": { km: 14, min: 28 },
    "den-haag-centraal": { km: 16, min: 33 },
    "dusseldorf-airport": { km: 251, min: 176 },
    "eindhoven-airport": { km: 142, min: 105 },
    "rotterdam": { km: 32, min: 38 },
    "rotterdam-centraal": { km: 31, min: 36 },
    "rotterdam-the-hague-airport": { km: 33, min: 31 },
    "schiphol": { km: 58, min: 57 },
    "utrecht": { km: 88, min: 75 },
    "utrecht-centraal": { km: 84, min: 68 },
  },
  "mookhoek": {
    "amsterdam": { km: 113, min: 88 },
    "amsterdam-centraal": { km: 109, min: 83 },
    "brussels-airport": { km: 125, min: 92 },
    "den-haag": { km: 60, min: 53 },
    "den-haag-centraal": { km: 55, min: 48 },
    "dusseldorf-airport": { km: 210, min: 146 },
    "eindhoven-airport": { km: 93, min: 71 },
    "rotterdam": { km: 31, min: 35 },
    "rotterdam-centraal": { km: 38, min: 38 },
    "rotterdam-the-hague-airport": { km: 40, min: 33 },
    "schiphol": { km: 92, min: 68 },
    "utrecht": { km: 83, min: 68 },
    "utrecht-centraal": { km: 79, min: 61 },
  },
  "moordrecht": {
    "amsterdam": { km: 76, min: 60 },
    "amsterdam-centraal": { km: 79, min: 60 },
    "brussels-airport": { km: 154, min: 107 },
    "den-haag": { km: 30, min: 29 },
    "den-haag-centraal": { km: 27, min: 25 },
    "dusseldorf-airport": { km: 231, min: 148 },
    "eindhoven-airport": { km: 122, min: 85 },
    "rotterdam": { km: 21, min: 25 },
    "rotterdam-centraal": { km: 20, min: 23 },
    "rotterdam-the-hague-airport": { km: 23, min: 17 },
    "schiphol": { km: 62, min: 45 },
    "utrecht": { km: 44, min: 38 },
    "utrecht-centraal": { km: 40, min: 31 },
  },
  "naaldwijk": {
    "amsterdam": { km: 79, min: 72 },
    "amsterdam-centraal": { km: 76, min: 67 },
    "brussels-airport": { km: 166, min: 119 },
    "den-haag": { km: 18, min: 36 },
    "den-haag-centraal": { km: 22, min: 32 },
    "dusseldorf-airport": { km: 246, min: 170 },
    "eindhoven-airport": { km: 136, min: 99 },
    "rotterdam": { km: 26, min: 32 },
    "rotterdam-centraal": { km: 26, min: 30 },
    "rotterdam-the-hague-airport": { km: 27, min: 25 },
    "schiphol": { km: 59, min: 52 },
    "utrecht": { km: 83, min: 69 },
    "utrecht-centraal": { km: 79, min: 62 },
  },
  "nieuw-beijerland": {
    "amsterdam": { km: 111, min: 86 },
    "amsterdam-centraal": { km: 108, min: 80 },
    "brussels-airport": { km: 127, min: 93 },
    "den-haag": { km: 58, min: 50 },
    "den-haag-centraal": { km: 54, min: 46 },
    "dusseldorf-airport": { km: 234, min: 160 },
    "eindhoven-airport": { km: 118, min: 85 },
    "rotterdam": { km: 27, min: 37 },
    "rotterdam-centraal": { km: 28, min: 36 },
    "rotterdam-the-hague-airport": { km: 43, min: 33 },
    "schiphol": { km: 90, min: 66 },
    "utrecht": { km: 85, min: 68 },
    "utrecht-centraal": { km: 81, min: 61 },
  },
  "nieuw-lekkerland": {
    "amsterdam": { km: 92, min: 77 },
    "amsterdam-centraal": { km: 99, min: 79 },
    "brussels-airport": { km: 148, min: 109 },
    "den-haag": { km: 60, min: 54 },
    "den-haag-centraal": { km: 56, min: 49 },
    "dusseldorf-airport": { km: 207, min: 141 },
    "eindhoven-airport": { km: 104, min: 75 },
    "rotterdam": { km: 31, min: 37 },
    "rotterdam-centraal": { km: 38, min: 40 },
    "rotterdam-the-hague-airport": { km: 41, min: 34 },
    "schiphol": { km: 93, min: 70 },
    "utrecht": { km: 58, min: 52 },
    "utrecht-centraal": { km: 56, min: 48 },
  },
  "nieuwe-tonge": {
    "amsterdam": { km: 132, min: 98 },
    "amsterdam-centraal": { km: 129, min: 92 },
    "brussels-airport": { km: 130, min: 94 },
    "den-haag": { km: 79, min: 62 },
    "den-haag-centraal": { km: 75, min: 57 },
    "dusseldorf-airport": { km: 238, min: 161 },
    "eindhoven-airport": { km: 121, min: 87 },
    "rotterdam": { km: 47, min: 49 },
    "rotterdam-centraal": { km: 48, min: 48 },
    "rotterdam-the-hague-airport": { km: 63, min: 45 },
    "schiphol": { km: 111, min: 77 },
    "utrecht": { km: 106, min: 80 },
    "utrecht-centraal": { km: 102, min: 73 },
  },
  "nieuwe-wetering": {
    "amsterdam": { km: 39, min: 39 },
    "amsterdam-centraal": { km: 36, min: 34 },
    "brussels-airport": { km: 189, min: 130 },
    "den-haag": { km: 31, min: 31 },
    "den-haag-centraal": { km: 29, min: 26 },
    "dusseldorf-airport": { km: 252, min: 165 },
    "eindhoven-airport": { km: 157, min: 108 },
    "rotterdam": { km: 45, min: 39 },
    "rotterdam-centraal": { km: 44, min: 37 },
    "rotterdam-the-hague-airport": { km: 40, min: 28 },
    "schiphol": { km: 18, min: 19 },
    "utrecht": { km: 65, min: 56 },
    "utrecht-centraal": { km: 61, min: 49 },
  },
  "nieuwegein": {
    "amsterdam": { km: 47, min: 44 },
    "amsterdam-centraal": { km: 55, min: 46 },
    "brussels-airport": { km: 159, min: 114 },
    "den-haag": { km: 64, min: 52 },
    "den-haag-centraal": { km: 62, min: 47 },
    "dusseldorf-airport": { km: 203, min: 133 },
    "eindhoven-airport": { km: 106, min: 77 },
    "rotterdam": { km: 59, min: 50 },
    "rotterdam-centraal": { km: 58, min: 48 },
    "rotterdam-the-hague-airport": { km: 61, min: 43 },
    "schiphol": { km: 54, min: 41 },
    "utrecht": { km: 12, min: 23 },
    "utrecht-centraal": { km: 11, min: 15 },
  },
  "nieuwerbrug-aan-den-rijn": {
    "amsterdam": { km: 47, min: 54 },
    "amsterdam-centraal": { km: 57, min: 55 },
    "brussels-airport": { km: 170, min: 121 },
    "den-haag": { km: 43, min: 40 },
    "den-haag-centraal": { km: 40, min: 35 },
    "dusseldorf-airport": { km: 217, min: 144 },
    "eindhoven-airport": { km: 128, min: 92 },
    "rotterdam": { km: 37, min: 39 },
    "rotterdam-centraal": { km: 37, min: 37 },
    "rotterdam-the-hague-airport": { km: 39, min: 31 },
    "schiphol": { km: 40, min: 40 },
    "utrecht": { km: 30, min: 34 },
    "utrecht-centraal": { km: 26, min: 27 },
  },
  "nieuwerkerk-aan-den-ijssel": {
    "amsterdam": { km: 80, min: 64 },
    "amsterdam-centraal": { km: 81, min: 64 },
    "brussels-airport": { km: 151, min: 107 },
    "den-haag": { km: 32, min: 34 },
    "den-haag-centraal": { km: 29, min: 29 },
    "dusseldorf-airport": { km: 235, min: 152 },
    "eindhoven-airport": { km: 119, min: 85 },
    "rotterdam": { km: 18, min: 25 },
    "rotterdam-centraal": { km: 17, min: 23 },
    "rotterdam-the-hague-airport": { km: 20, min: 17 },
    "schiphol": { km: 64, min: 50 },
    "utrecht": { km: 48, min: 43 },
    "utrecht-centraal": { km: 44, min: 36 },
  },
  "nieuwkoop": {
    "amsterdam": { km: 46, min: 50 },
    "amsterdam-centraal": { km: 40, min: 44 },
    "brussels-airport": { km: 180, min: 130 },
    "den-haag": { km: 43, min: 43 },
    "den-haag-centraal": { km: 41, min: 38 },
    "dusseldorf-airport": { km: 231, min: 157 },
    "eindhoven-airport": { km: 141, min: 105 },
    "rotterdam": { km: 48, min: 48 },
    "rotterdam-centraal": { km: 47, min: 46 },
    "rotterdam-the-hague-airport": { km: 52, min: 40 },
    "schiphol": { km: 26, min: 31 },
    "utrecht": { km: 43, min: 47 },
    "utrecht-centraal": { km: 35, min: 38 },
  },
  "nieuwpoort": {
    "amsterdam": { km: 76, min: 66 },
    "amsterdam-centraal": { km: 84, min: 67 },
    "brussels-airport": { km: 143, min: 107 },
    "den-haag": { km: 72, min: 66 },
    "den-haag-centraal": { km: 67, min: 61 },
    "dusseldorf-airport": { km: 195, min: 136 },
    "eindhoven-airport": { km: 91, min: 70 },
    "rotterdam": { km: 43, min: 48 },
    "rotterdam-centraal": { km: 50, min: 51 },
    "rotterdam-the-hague-airport": { km: 52, min: 46 },
    "schiphol": { km: 83, min: 63 },
    "utrecht": { km: 43, min: 41 },
    "utrecht-centraal": { km: 40, min: 37 },
  },
  "nieuwveen": {
    "amsterdam": { km: 36, min: 42 },
    "amsterdam-centraal": { km: 33, min: 37 },
    "brussels-airport": { km: 183, min: 135 },
    "den-haag": { km: 45, min: 44 },
    "den-haag-centraal": { km: 43, min: 40 },
    "dusseldorf-airport": { km: 231, min: 159 },
    "eindhoven-airport": { km: 142, min: 107 },
    "rotterdam": { km: 59, min: 53 },
    "rotterdam-centraal": { km: 59, min: 51 },
    "rotterdam-the-hague-airport": { km: 54, min: 42 },
    "schiphol": { km: 21, min: 24 },
    "utrecht": { km: 44, min: 49 },
    "utrecht-centraal": { km: 36, min: 40 },
  },
  "noordeloos": {
    "amsterdam": { km: 69, min: 58 },
    "amsterdam-centraal": { km: 77, min: 59 },
    "brussels-airport": { km: 141, min: 101 },
    "den-haag": { km: 70, min: 64 },
    "den-haag-centraal": { km: 66, min: 59 },
    "dusseldorf-airport": { km: 191, min: 129 },
    "eindhoven-airport": { km: 87, min: 63 },
    "rotterdam": { km: 41, min: 46 },
    "rotterdam-centraal": { km: 48, min: 49 },
    "rotterdam-the-hague-airport": { km: 51, min: 44 },
    "schiphol": { km: 76, min: 55 },
    "utrecht": { km: 35, min: 33 },
    "utrecht-centraal": { km: 33, min: 29 },
  },
  "noorden": {
    "amsterdam": { km: 42, min: 44 },
    "amsterdam-centraal": { km: 39, min: 43 },
    "brussels-airport": { km: 185, min: 135 },
    "den-haag": { km: 47, min: 49 },
    "den-haag-centraal": { km: 45, min: 44 },
    "dusseldorf-airport": { km: 227, min: 151 },
    "eindhoven-airport": { km: 137, min: 98 },
    "rotterdam": { km: 52, min: 53 },
    "rotterdam-centraal": { km: 51, min: 51 },
    "rotterdam-the-hague-airport": { km: 56, min: 46 },
    "schiphol": { km: 27, min: 31 },
    "utrecht": { km: 39, min: 41 },
    "utrecht-centraal": { km: 31, min: 32 },
  },
  "noordwijk": {
    "amsterdam": { km: 49, min: 50 },
    "amsterdam-centraal": { km: 46, min: 45 },
    "brussels-airport": { km: 195, min: 138 },
    "den-haag": { km: 29, min: 36 },
    "den-haag-centraal": { km: 29, min: 35 },
    "dusseldorf-airport": { km: 264, min: 176 },
    "eindhoven-airport": { km: 164, min: 116 },
    "rotterdam": { km: 51, min: 47 },
    "rotterdam-centraal": { km: 51, min: 45 },
    "rotterdam-the-hague-airport": { km: 46, min: 36 },
    "schiphol": { km: 29, min: 30 },
    "utrecht": { km: 77, min: 66 },
    "utrecht-centraal": { km: 73, min: 60 },
  },
  "noordwijkerhout": {
    "amsterdam": { km: 47, min: 49 },
    "amsterdam-centraal": { km: 44, min: 43 },
    "brussels-airport": { km: 196, min: 136 },
    "den-haag": { km: 30, min: 35 },
    "den-haag-centraal": { km: 30, min: 34 },
    "dusseldorf-airport": { km: 264, min: 175 },
    "eindhoven-airport": { km: 164, min: 115 },
    "rotterdam": { km: 52, min: 46 },
    "rotterdam-centraal": { km: 51, min: 44 },
    "rotterdam-the-hague-airport": { km: 47, min: 35 },
    "schiphol": { km: 27, min: 29 },
    "utrecht": { km: 77, min: 65 },
    "utrecht-centraal": { km: 73, min: 58 },
  },
  "nootdorp": {
    "amsterdam": { km: 64, min: 55 },
    "amsterdam-centraal": { km: 61, min: 50 },
    "brussels-airport": { km: 170, min: 118 },
    "den-haag": { km: 12, min: 19 },
    "den-haag-centraal": { km: 9, min: 14 },
    "dusseldorf-airport": { km: 248, min: 161 },
    "eindhoven-airport": { km: 138, min: 97 },
    "rotterdam": { km: 26, min: 28 },
    "rotterdam-centraal": { km: 25, min: 25 },
    "rotterdam-the-hague-airport": { km: 20, min: 17 },
    "schiphol": { km: 44, min: 35 },
    "utrecht": { km: 61, min: 51 },
    "utrecht-centraal": { km: 57, min: 44 },
  },
  "numansdorp": {
    "amsterdam": { km: 114, min: 86 },
    "amsterdam-centraal": { km: 111, min: 81 },
    "brussels-airport": { km: 124, min: 90 },
    "den-haag": { km: 61, min: 50 },
    "den-haag-centraal": { km: 57, min: 46 },
    "dusseldorf-airport": { km: 231, min: 157 },
    "eindhoven-airport": { km: 115, min: 82 },
    "rotterdam": { km: 30, min: 37 },
    "rotterdam-centraal": { km: 31, min: 37 },
    "rotterdam-the-hague-airport": { km: 46, min: 33 },
    "schiphol": { km: 93, min: 66 },
    "utrecht": { km: 88, min: 68 },
    "utrecht-centraal": { km: 84, min: 61 },
  },
  "oegstgeest": {
    "amsterdam": { km: 48, min: 45 },
    "amsterdam-centraal": { km: 45, min: 40 },
    "brussels-airport": { km: 184, min: 129 },
    "den-haag": { km: 18, min: 27 },
    "den-haag-centraal": { km: 17, min: 26 },
    "dusseldorf-airport": { km: 252, min: 167 },
    "eindhoven-airport": { km: 152, min: 107 },
    "rotterdam": { km: 40, min: 38 },
    "rotterdam-centraal": { km: 39, min: 36 },
    "rotterdam-the-hague-airport": { km: 35, min: 27 },
    "schiphol": { km: 27, min: 25 },
    "utrecht": { km: 65, min: 57 },
    "utrecht-centraal": { km: 61, min: 50 },
  },
  "ooltgensplaat": {
    "amsterdam": { km: 125, min: 93 },
    "amsterdam-centraal": { km: 122, min: 87 },
    "brussels-airport": { km: 124, min: 89 },
    "den-haag": { km: 73, min: 57 },
    "den-haag-centraal": { km: 68, min: 52 },
    "dusseldorf-airport": { km: 231, min: 156 },
    "eindhoven-airport": { km: 115, min: 82 },
    "rotterdam": { km: 41, min: 44 },
    "rotterdam-centraal": { km: 42, min: 43 },
    "rotterdam-the-hague-airport": { km: 57, min: 40 },
    "schiphol": { km: 105, min: 72 },
    "utrecht": { km: 100, min: 75 },
    "utrecht-centraal": { km: 96, min: 68 },
  },
  "oostvoorne": {
    "amsterdam": { km: 102, min: 78 },
    "amsterdam-centraal": { km: 99, min: 73 },
    "brussels-airport": { km: 171, min: 119 },
    "den-haag": { km: 49, min: 42 },
    "den-haag-centraal": { km: 45, min: 38 },
    "dusseldorf-airport": { km: 249, min: 169 },
    "eindhoven-airport": { km: 140, min: 98 },
    "rotterdam": { km: 33, min: 33 },
    "rotterdam-centraal": { km: 33, min: 30 },
    "rotterdam-the-hague-airport": { km: 34, min: 26 },
    "schiphol": { km: 81, min: 58 },
    "utrecht": { km: 90, min: 69 },
    "utrecht-centraal": { km: 86, min: 63 },
  },
  "ottoland": {
    "amsterdam": { km: 76, min: 65 },
    "amsterdam-centraal": { km: 84, min: 67 },
    "brussels-airport": { km: 141, min: 106 },
    "den-haag": { km: 66, min: 60 },
    "den-haag-centraal": { km: 62, min: 55 },
    "dusseldorf-airport": { km: 193, min: 134 },
    "eindhoven-airport": { km: 89, min: 68 },
    "rotterdam": { km: 37, min: 43 },
    "rotterdam-centraal": { km: 44, min: 46 },
    "rotterdam-the-hague-airport": { km: 47, min: 40 },
    "schiphol": { km: 84, min: 63 },
    "utrecht": { km: 43, min: 41 },
    "utrecht-centraal": { km: 41, min: 37 },
  },
  "oud-ade": {
    "amsterdam": { km: 42, min: 44 },
    "amsterdam-centraal": { km: 39, min: 39 },
    "brussels-airport": { km: 188, min: 131 },
    "den-haag": { km: 30, min: 32 },
    "den-haag-centraal": { km: 27, min: 28 },
    "dusseldorf-airport": { km: 251, min: 167 },
    "eindhoven-airport": { km: 156, min: 110 },
    "rotterdam": { km: 44, min: 41 },
    "rotterdam-centraal": { km: 43, min: 39 },
    "rotterdam-the-hague-airport": { km: 39, min: 30 },
    "schiphol": { km: 22, min: 24 },
    "utrecht": { km: 64, min: 57 },
    "utrecht-centraal": { km: 60, min: 50 },
  },
  "oud-alblas": {
    "amsterdam": { km: 87, min: 74 },
    "amsterdam-centraal": { km: 95, min: 75 },
    "brussels-airport": { km: 139, min: 103 },
    "den-haag": { km: 51, min: 48 },
    "den-haag-centraal": { km: 47, min: 43 },
    "dusseldorf-airport": { km: 203, min: 138 },
    "eindhoven-airport": { km: 99, min: 72 },
    "rotterdam": { km: 22, min: 31 },
    "rotterdam-centraal": { km: 29, min: 33 },
    "rotterdam-the-hague-airport": { km: 32, min: 28 },
    "schiphol": { km: 84, min: 64 },
    "utrecht": { km: 53, min: 49 },
    "utrecht-centraal": { km: 51, min: 45 },
  },
  "oud-beijerland": {
    "amsterdam": { km: 105, min: 85 },
    "amsterdam-centraal": { km: 102, min: 79 },
    "brussels-airport": { km: 130, min: 99 },
    "den-haag": { km: 53, min: 49 },
    "den-haag-centraal": { km: 49, min: 44 },
    "dusseldorf-airport": { km: 227, min: 159 },
    "eindhoven-airport": { km: 107, min: 87 },
    "rotterdam": { km: 21, min: 36 },
    "rotterdam-centraal": { km: 22, min: 35 },
    "rotterdam-the-hague-airport": { km: 37, min: 32 },
    "schiphol": { km: 85, min: 64 },
    "utrecht": { km: 80, min: 67 },
    "utrecht-centraal": { km: 76, min: 60 },
  },
  "ouddorp": {
    "amsterdam": { km: 121, min: 95 },
    "amsterdam-centraal": { km: 118, min: 90 },
    "brussels-airport": { km: 158, min: 120 },
    "den-haag": { km: 69, min: 60 },
    "den-haag-centraal": { km: 64, min: 55 },
    "dusseldorf-airport": { km: 269, min: 186 },
    "eindhoven-airport": { km: 149, min: 112 },
    "rotterdam": { km: 53, min: 50 },
    "rotterdam-centraal": { km: 52, min: 47 },
    "rotterdam-the-hague-airport": { km: 54, min: 43 },
    "schiphol": { km: 101, min: 75 },
    "utrecht": { km: 109, min: 87 },
    "utrecht-centraal": { km: 105, min: 80 },
  },
  "oude-tonge": {
    "amsterdam": { km: 127, min: 96 },
    "amsterdam-centraal": { km: 124, min: 91 },
    "brussels-airport": { km: 126, min: 93 },
    "den-haag": { km: 75, min: 61 },
    "den-haag-centraal": { km: 70, min: 56 },
    "dusseldorf-airport": { km: 234, min: 160 },
    "eindhoven-airport": { km: 117, min: 85 },
    "rotterdam": { km: 43, min: 48 },
    "rotterdam-centraal": { km: 44, min: 47 },
    "rotterdam-the-hague-airport": { km: 59, min: 44 },
    "schiphol": { km: 107, min: 76 },
    "utrecht": { km: 102, min: 79 },
    "utrecht-centraal": { km: 98, min: 72 },
  },
  "oude-wetering": {
    "amsterdam": { km: 37, min: 38 },
    "amsterdam-centraal": { km: 34, min: 33 },
    "brussels-airport": { km: 190, min: 132 },
    "den-haag": { km: 32, min: 34 },
    "den-haag-centraal": { km: 30, min: 29 },
    "dusseldorf-airport": { km: 247, min: 167 },
    "eindhoven-airport": { km: 159, min: 111 },
    "rotterdam": { km: 47, min: 42 },
    "rotterdam-centraal": { km: 46, min: 40 },
    "rotterdam-the-hague-airport": { km: 41, min: 31 },
    "schiphol": { km: 16, min: 18 },
    "utrecht": { km: 60, min: 57 },
    "utrecht-centraal": { km: 63, min: 49 },
  },
  "oudenhoorn": {
    "amsterdam": { km: 104, min: 84 },
    "amsterdam-centraal": { km: 101, min: 79 },
    "brussels-airport": { km: 165, min: 121 },
    "den-haag": { km: 51, min: 49 },
    "den-haag-centraal": { km: 47, min: 44 },
    "dusseldorf-airport": { km: 243, min: 171 },
    "eindhoven-airport": { km: 134, min: 100 },
    "rotterdam": { km: 36, min: 39 },
    "rotterdam-centraal": { km: 35, min: 37 },
    "rotterdam-the-hague-airport": { km: 36, min: 32 },
    "schiphol": { km: 84, min: 64 },
    "utrecht": { km: 92, min: 76 },
    "utrecht-centraal": { km: 88, min: 69 },
  },
  "ouderkerk-aan-den-ijssel": {
    "amsterdam": { km: 84, min: 81 },
    "amsterdam-centraal": { km: 92, min: 82 },
    "brussels-airport": { km: 169, min: 131 },
    "den-haag": { km: 45, min: 54 },
    "den-haag-centraal": { km: 43, min: 49 },
    "dusseldorf-airport": { km: 240, min: 170 },
    "eindhoven-airport": { km: 112, min: 110 },
    "rotterdam": { km: 36, min: 49 },
    "rotterdam-centraal": { km: 35, min: 47 },
    "rotterdam-the-hague-airport": { km: 38, min: 42 },
    "schiphol": { km: 57, min: 68 },
    "utrecht": { km: 53, min: 59 },
    "utrecht-centraal": { km: 48, min: 52 },
  },
  "papendrecht": {
    "amsterdam": { km: 91, min: 73 },
    "amsterdam-centraal": { km: 99, min: 75 },
    "brussels-airport": { km: 139, min: 103 },
    "den-haag": { km: 51, min: 49 },
    "den-haag-centraal": { km: 47, min: 44 },
    "dusseldorf-airport": { km: 200, min: 135 },
    "eindhoven-airport": { km: 97, min: 69 },
    "rotterdam": { km: 22, min: 31 },
    "rotterdam-centraal": { km: 29, min: 34 },
    "rotterdam-the-hague-airport": { km: 32, min: 29 },
    "schiphol": { km: 83, min: 64 },
    "utrecht": { km: 58, min: 48 },
    "utrecht-centraal": { km: 56, min: 44 },
  },
  "pernis-rotterdam": {
    "amsterdam": { km: 85, min: 66 },
    "amsterdam-centraal": { km: 82, min: 60 },
    "brussels-airport": { km: 144, min: 102 },
    "den-haag": { km: 32, min: 30 },
    "den-haag-centraal": { km: 28, min: 26 },
    "dusseldorf-airport": { km: 224, min: 153 },
    "eindhoven-airport": { km: 115, min: 82 },
    "rotterdam": { km: 17, min: 21 },
    "rotterdam-centraal": { km: 16, min: 18 },
    "rotterdam-the-hague-airport": { km: 17, min: 14 },
    "schiphol": { km: 65, min: 46 },
    "utrecht": { km: 73, min: 58 },
    "utrecht-centraal": { km: 69, min: 51 },
  },
  "piershil": {
    "amsterdam": { km: 114, min: 89 },
    "amsterdam-centraal": { km: 111, min: 83 },
    "brussels-airport": { km: 129, min: 95 },
    "den-haag": { km: 61, min: 53 },
    "den-haag-centraal": { km: 57, min: 48 },
    "dusseldorf-airport": { km: 237, min: 162 },
    "eindhoven-airport": { km: 120, min: 87 },
    "rotterdam": { km: 30, min: 40 },
    "rotterdam-centraal": { km: 31, min: 39 },
    "rotterdam-the-hague-airport": { km: 45, min: 36 },
    "schiphol": { km: 93, min: 69 },
    "utrecht": { km: 88, min: 71 },
    "utrecht-centraal": { km: 84, min: 64 },
  },
  "pijnacker": {
    "amsterdam": { km: 68, min: 60 },
    "amsterdam-centraal": { km: 65, min: 55 },
    "brussels-airport": { km: 155, min: 111 },
    "den-haag": { km: 16, min: 24 },
    "den-haag-centraal": { km: 13, min: 19 },
    "dusseldorf-airport": { km: 233, min: 161 },
    "eindhoven-airport": { km: 123, min: 89 },
    "rotterdam": { km: 17, min: 23 },
    "rotterdam-centraal": { km: 16, min: 21 },
    "rotterdam-the-hague-airport": { km: 12, min: 12 },
    "schiphol": { km: 48, min: 40 },
    "utrecht": { km: 59, min: 53 },
    "utrecht-centraal": { km: 55, min: 47 },
  },
  "poeldijk": {
    "amsterdam": { km: 75, min: 71 },
    "amsterdam-centraal": { km: 71, min: 66 },
    "brussels-airport": { km: 169, min: 121 },
    "den-haag": { km: 13, min: 27 },
    "den-haag-centraal": { km: 12, min: 27 },
    "dusseldorf-airport": { km: 249, min: 172 },
    "eindhoven-airport": { km: 140, min: 101 },
    "rotterdam": { km: 30, min: 34 },
    "rotterdam-centraal": { km: 29, min: 32 },
    "rotterdam-the-hague-airport": { km: 30, min: 27 },
    "schiphol": { km: 54, min: 51 },
    "utrecht": { km: 75, min: 70 },
    "utrecht-centraal": { km: 71, min: 63 },
  },
  "poortugaal": {
    "amsterdam": { km: 91, min: 73 },
    "amsterdam-centraal": { km: 88, min: 67 },
    "brussels-airport": { km: 143, min: 102 },
    "den-haag": { km: 38, min: 37 },
    "den-haag-centraal": { km: 34, min: 33 },
    "dusseldorf-airport": { km: 222, min: 153 },
    "eindhoven-airport": { km: 113, min: 81 },
    "rotterdam": { km: 12, min: 27 },
    "rotterdam-centraal": { km: 12, min: 25 },
    "rotterdam-the-hague-airport": { km: 23, min: 21 },
    "schiphol": { km: 71, min: 53 },
    "utrecht": { km: 76, min: 61 },
    "utrecht-centraal": { km: 72, min: 54 },
  },
  "purmerend": {
    "amsterdam": { km: 19, min: 28 },
    "amsterdam-centraal": { km: 25, min: 26 },
    "brussels-airport": { km: 218, min: 155 },
    "den-haag": { km: 80, min: 62 },
    "den-haag-centraal": { km: 78, min: 57 },
    "dusseldorf-airport": { km: 245, min: 163 },
    "eindhoven-airport": { km: 165, min: 117 },
    "rotterdam": { km: 94, min: 71 },
    "rotterdam-centraal": { km: 93, min: 68 },
    "rotterdam-the-hague-airport": { km: 89, min: 59 },
    "schiphol": { km: 37, min: 32 },
    "utrecht": { km: 64, min: 56 },
    "utrecht-centraal": { km: 59, min: 51 },
  },
  "puttershoek": {
    "amsterdam": { km: 106, min: 83 },
    "amsterdam-centraal": { km: 103, min: 77 },
    "brussels-airport": { km: 126, min: 94 },
    "den-haag": { km: 53, min: 47 },
    "den-haag-centraal": { km: 49, min: 42 },
    "dusseldorf-airport": { km: 211, min: 147 },
    "eindhoven-airport": { km: 94, min: 72 },
    "rotterdam": { km: 21, min: 34 },
    "rotterdam-centraal": { km: 23, min: 33 },
    "rotterdam-the-hague-airport": { km: 37, min: 30 },
    "schiphol": { km: 85, min: 63 },
    "utrecht": { km: 80, min: 65 },
    "utrecht-centraal": { km: 76, min: 58 },
  },
  "reeuwijk": {
    "amsterdam": { km: 68, min: 57 },
    "amsterdam-centraal": { km: 56, min: 55 },
    "brussels-airport": { km: 163, min: 114 },
    "den-haag": { km: 36, min: 34 },
    "den-haag-centraal": { km: 33, min: 29 },
    "dusseldorf-airport": { km: 223, min: 145 },
    "eindhoven-airport": { km: 131, min: 93 },
    "rotterdam": { km: 30, min: 32 },
    "rotterdam-centraal": { km: 29, min: 30 },
    "rotterdam-the-hague-airport": { km: 32, min: 25 },
    "schiphol": { km: 39, min: 40 },
    "utrecht": { km: 36, min: 35 },
    "utrecht-centraal": { km: 32, min: 28 },
  },
  "rhoon": {
    "amsterdam": { km: 89, min: 70 },
    "amsterdam-centraal": { km: 86, min: 65 },
    "brussels-airport": { km: 141, min: 99 },
    "den-haag": { km: 37, min: 34 },
    "den-haag-centraal": { km: 32, min: 30 },
    "dusseldorf-airport": { km: 221, min: 150 },
    "eindhoven-airport": { km: 111, min: 79 },
    "rotterdam": { km: 11, min: 24 },
    "rotterdam-centraal": { km: 10, min: 23 },
    "rotterdam-the-hague-airport": { km: 22, min: 18 },
    "schiphol": { km: 69, min: 50 },
    "utrecht": { km: 74, min: 58 },
    "utrecht-centraal": { km: 70, min: 51 },
  },
  "ridderkerk": {
    "amsterdam": { km: 96, min: 76 },
    "amsterdam-centraal": { km: 93, min: 71 },
    "brussels-airport": { km: 132, min: 98 },
    "den-haag": { km: 44, min: 40 },
    "den-haag-centraal": { km: 39, min: 35 },
    "dusseldorf-airport": { km: 209, min: 145 },
    "eindhoven-airport": { km: 101, min: 76 },
    "rotterdam": { km: 14, min: 23 },
    "rotterdam-centraal": { km: 21, min: 26 },
    "rotterdam-the-hague-airport": { km: 24, min: 20 },
    "schiphol": { km: 76, min: 56 },
    "utrecht": { km: 67, min: 55 },
    "utrecht-centraal": { km: 62, min: 48 },
  },
  "rijnsaterwoude": {
    "amsterdam": { km: 37, min: 39 },
    "amsterdam-centraal": { km: 34, min: 34 },
    "brussels-airport": { km: 183, min: 132 },
    "den-haag": { km: 37, min: 38 },
    "den-haag-centraal": { km: 34, min: 33 },
    "dusseldorf-airport": { km: 240, min: 159 },
    "eindhoven-airport": { km: 151, min: 107 },
    "rotterdam": { km: 51, min: 46 },
    "rotterdam-centraal": { km: 50, min: 44 },
    "rotterdam-the-hague-airport": { km: 46, min: 35 },
    "schiphol": { km: 17, min: 19 },
    "utrecht": { km: 53, min: 49 },
    "utrecht-centraal": { km: 49, min: 42 },
  },
  "rijnsburg": {
    "amsterdam": { km: 50, min: 48 },
    "amsterdam-centraal": { km: 46, min: 42 },
    "brussels-airport": { km: 185, min: 130 },
    "den-haag": { km: 19, min: 29 },
    "den-haag-centraal": { km: 19, min: 28 },
    "dusseldorf-airport": { km: 253, min: 169 },
    "eindhoven-airport": { km: 153, min: 109 },
    "rotterdam": { km: 41, min: 40 },
    "rotterdam-centraal": { km: 40, min: 38 },
    "rotterdam-the-hague-airport": { km: 36, min: 29 },
    "schiphol": { km: 29, min: 27 },
    "utrecht": { km: 66, min: 59 },
    "utrecht-centraal": { km: 62, min: 52 },
  },
  "rijpwetering": {
    "amsterdam": { km: 39, min: 38 },
    "amsterdam-centraal": { km: 36, min: 32 },
    "brussels-airport": { km: 189, min: 129 },
    "den-haag": { km: 31, min: 30 },
    "den-haag-centraal": { km: 29, min: 25 },
    "dusseldorf-airport": { km: 252, min: 164 },
    "eindhoven-airport": { km: 158, min: 107 },
    "rotterdam": { km: 45, min: 38 },
    "rotterdam-centraal": { km: 44, min: 36 },
    "rotterdam-the-hague-airport": { km: 40, min: 27 },
    "schiphol": { km: 19, min: 18 },
    "utrecht": { km: 65, min: 54 },
    "utrecht-centraal": { km: 61, min: 47 },
  },
  "rijswijk": {
    "amsterdam": { km: 65, min: 54 },
    "amsterdam-centraal": { km: 62, min: 49 },
    "brussels-airport": { km: 164, min: 114 },
    "den-haag": { km: 12, min: 18 },
    "den-haag-centraal": { km: 8, min: 14 },
    "dusseldorf-airport": { km: 253, min: 163 },
    "eindhoven-airport": { km: 132, min: 92 },
    "rotterdam": { km: 20, min: 23 },
    "rotterdam-centraal": { km: 19, min: 21 },
    "rotterdam-the-hague-airport": { km: 15, min: 12 },
    "schiphol": { km: 44, min: 34 },
    "utrecht": { km: 65, min: 53 },
    "utrecht-centraal": { km: 61, min: 46 },
  },
  "rockanje": {
    "amsterdam": { km: 106, min: 87 },
    "amsterdam-centraal": { km: 103, min: 82 },
    "brussels-airport": { km: 162, min: 126 },
    "den-haag": { km: 54, min: 52 },
    "den-haag-centraal": { km: 49, min: 47 },
    "dusseldorf-airport": { km: 254, min: 178 },
    "eindhoven-airport": { km: 144, min: 107 },
    "rotterdam": { km: 38, min: 42 },
    "rotterdam-centraal": { km: 37, min: 39 },
    "rotterdam-the-hague-airport": { km: 38, min: 35 },
    "schiphol": { km: 86, min: 67 },
    "utrecht": { km: 94, min: 79 },
    "utrecht-centraal": { km: 90, min: 72 },
  },
  "roelofarendsveen": {
    "amsterdam": { km: 39, min: 40 },
    "amsterdam-centraal": { km: 36, min: 35 },
    "brussels-airport": { km: 190, min: 132 },
    "den-haag": { km: 32, min: 33 },
    "den-haag-centraal": { km: 29, min: 28 },
    "dusseldorf-airport": { km: 253, min: 168 },
    "eindhoven-airport": { km: 158, min: 110 },
    "rotterdam": { km: 46, min: 42 },
    "rotterdam-centraal": { km: 45, min: 39 },
    "rotterdam-the-hague-airport": { km: 41, min: 30 },
    "schiphol": { km: 19, min: 20 },
    "utrecht": { km: 66, min: 58 },
    "utrecht-centraal": { km: 62, min: 51 },
  },
  "rotterdam": {
    "amsterdam": { km: 80, min: 68 },
    "amsterdam-centraal": { km: 76, min: 62 },
    "brussels-airport": { km: 141, min: 105 },
    "den-haag": { km: 27, min: 32 },
    "den-haag-centraal": { km: 22, min: 27 },
    "dusseldorf-airport": { km: 219, min: 155 },
    "eindhoven-airport": { km: 110, min: 84 },
    "rotterdam-centraal": { km: 3, min: 10 },
    "rotterdam-the-hague-airport": { km: 8, min: 12 },
    "schiphol": { km: 59, min: 47 },
    "utrecht": { km: 60, min: 54 },
    "utrecht-centraal": { km: 56, min: 47 },
  },
  "rotterdam-albrandswaard": {
    "amsterdam": { km: 87, min: 67 },
    "amsterdam-centraal": { km: 84, min: 61 },
    "brussels-airport": { km: 141, min: 98 },
    "den-haag": { km: 34, min: 31 },
    "den-haag-centraal": { km: 30, min: 27 },
    "dusseldorf-airport": { km: 220, min: 148 },
    "eindhoven-airport": { km: 111, min: 77 },
    "rotterdam": { km: 10, min: 22 },
    "rotterdam-centraal": { km: 10, min: 21 },
    "rotterdam-the-hague-airport": { km: 19, min: 15 },
    "schiphol": { km: 66, min: 47 },
    "utrecht": { km: 73, min: 57 },
    "utrecht-centraal": { km: 69, min: 50 },
  },
  "rozenburg": {
    "amsterdam": { km: 91, min: 70 },
    "amsterdam-centraal": { km: 88, min: 65 },
    "brussels-airport": { km: 161, min: 111 },
    "den-haag": { km: 39, min: 35 },
    "den-haag-centraal": { km: 34, min: 30 },
    "dusseldorf-airport": { km: 238, min: 161 },
    "eindhoven-airport": { km: 129, min: 90 },
    "rotterdam": { km: 23, min: 25 },
    "rotterdam-centraal": { km: 22, min: 22 },
    "rotterdam-the-hague-airport": { km: 23, min: 18 },
    "schiphol": { km: 71, min: 50 },
    "utrecht": { km: 79, min: 62 },
    "utrecht-centraal": { km: 75, min: 55 },
  },
  "s-gravendeel": {
    "amsterdam": { km: 110, min: 85 },
    "amsterdam-centraal": { km: 107, min: 80 },
    "brussels-airport": { km: 122, min: 89 },
    "den-haag": { km: 58, min: 50 },
    "den-haag-centraal": { km: 53, min: 45 },
    "dusseldorf-airport": { km: 207, min: 143 },
    "eindhoven-airport": { km: 91, min: 68 },
    "rotterdam": { km: 28, min: 32 },
    "rotterdam-centraal": { km: 35, min: 35 },
    "rotterdam-the-hague-airport": { km: 38, min: 30 },
    "schiphol": { km: 90, min: 65 },
    "utrecht": { km: 81, min: 64 },
    "utrecht-centraal": { km: 77, min: 58 },
  },
  "s-gravenzande": {
    "amsterdam": { km: 83, min: 73 },
    "amsterdam-centraal": { km: 80, min: 67 },
    "brussels-airport": { km: 168, min: 118 },
    "den-haag": { km: 20, min: 38 },
    "den-haag-centraal": { km: 26, min: 32 },
    "dusseldorf-airport": { km: 248, min: 169 },
    "eindhoven-airport": { km: 138, min: 98 },
    "rotterdam": { km: 28, min: 31 },
    "rotterdam-centraal": { km: 27, min: 29 },
    "rotterdam-the-hague-airport": { km: 29, min: 24 },
    "schiphol": { km: 62, min: 53 },
    "utrecht": { km: 84, min: 68 },
    "utrecht-centraal": { km: 80, min: 61 },
  },
  "sassenheim": {
    "amsterdam": { km: 43, min: 42 },
    "amsterdam-centraal": { km: 40, min: 36 },
    "brussels-airport": { km: 189, min: 130 },
    "den-haag": { km: 23, min: 29 },
    "den-haag-centraal": { km: 22, min: 28 },
    "dusseldorf-airport": { km: 257, min: 169 },
    "eindhoven-airport": { km: 157, min: 109 },
    "rotterdam": { km: 45, min: 40 },
    "rotterdam-centraal": { km: 44, min: 38 },
    "rotterdam-the-hague-airport": { km: 40, min: 29 },
    "schiphol": { km: 22, min: 22 },
    "utrecht": { km: 70, min: 59 },
    "utrecht-centraal": { km: 66, min: 52 },
  },
  "schagen": {
    "amsterdam": { km: 65, min: 64 },
    "amsterdam-centraal": { km: 61, min: 59 },
    "brussels-airport": { km: 263, min: 183 },
    "den-haag": { km: 105, min: 84 },
    "den-haag-centraal": { km: 103, min: 79 },
    "dusseldorf-airport": { km: 291, min: 198 },
    "eindhoven-airport": { km: 211, min: 148 },
    "rotterdam": { km: 119, min: 93 },
    "rotterdam-centraal": { km: 119, min: 90 },
    "rotterdam-the-hague-airport": { km: 114, min: 81 },
    "schiphol": { km: 65, min: 55 },
    "utrecht": { km: 113, min: 91 },
    "utrecht-centraal": { km: 105, min: 82 },
  },
  "schelluinen": {
    "amsterdam": { km: 76, min: 64 },
    "amsterdam-centraal": { km: 84, min: 66 },
    "brussels-airport": { km: 134, min: 98 },
    "den-haag": { km: 71, min: 61 },
    "den-haag-centraal": { km: 66, min: 56 },
    "dusseldorf-airport": { km: 185, min: 126 },
    "eindhoven-airport": { km: 81, min: 61 },
    "rotterdam": { km: 41, min: 44 },
    "rotterdam-centraal": { km: 48, min: 46 },
    "rotterdam-the-hague-airport": { km: 51, min: 41 },
    "schiphol": { km: 83, min: 62 },
    "utrecht": { km: 43, min: 40 },
    "utrecht-centraal": { km: 40, min: 36 },
  },
  "schiedam": {
    "amsterdam": { km: 79, min: 64 },
    "amsterdam-centraal": { km: 76, min: 59 },
    "brussels-airport": { km: 152, min: 107 },
    "den-haag": { km: 26, min: 28 },
    "den-haag-centraal": { km: 22, min: 24 },
    "dusseldorf-airport": { km: 231, min: 158 },
    "eindhoven-airport": { km: 122, min: 87 },
    "rotterdam": { km: 7, min: 18 },
    "rotterdam-centraal": { km: 7, min: 16 },
    "rotterdam-the-hague-airport": { km: 9, min: 11 },
    "schiphol": { km: 59, min: 44 },
    "utrecht": { km: 65, min: 55 },
    "utrecht-centraal": { km: 61, min: 48 },
  },
  "schipluiden": {
    "amsterdam": { km: 72, min: 62 },
    "amsterdam-centraal": { km: 69, min: 56 },
    "brussels-airport": { km: 161, min: 114 },
    "den-haag": { km: 20, min: 26 },
    "den-haag-centraal": { km: 15, min: 22 },
    "dusseldorf-airport": { km: 240, min: 165 },
    "eindhoven-airport": { km: 131, min: 93 },
    "rotterdam": { km: 21, min: 27 },
    "rotterdam-centraal": { km: 20, min: 25 },
    "rotterdam-the-hague-airport": { km: 16, min: 18 },
    "schiphol": { km: 52, min: 42 },
    "utrecht": { km: 73, min: 61 },
    "utrecht-centraal": { km: 69, min: 54 },
  },
  "schoonhoven": {
    "amsterdam": { km: 67, min: 62 },
    "amsterdam-centraal": { km: 74, min: 64 },
    "brussels-airport": { km: 174, min: 128 },
    "den-haag": { km: 50, min: 50 },
    "den-haag-centraal": { km: 47, min: 45 },
    "dusseldorf-airport": { km: 222, min: 151 },
    "eindhoven-airport": { km: 123, min: 92 },
    "rotterdam": { km: 41, min: 46 },
    "rotterdam-centraal": { km: 40, min: 44 },
    "rotterdam-the-hague-airport": { km: 43, min: 38 },
    "schiphol": { km: 74, min: 59 },
    "utrecht": { km: 35, min: 41 },
    "utrecht-centraal": { km: 31, min: 33 },
  },
  "simonshaven": {
    "amsterdam": { km: 99, min: 80 },
    "amsterdam-centraal": { km: 96, min: 74 },
    "brussels-airport": { km: 161, min: 116 },
    "den-haag": { km: 47, min: 44 },
    "den-haag-centraal": { km: 42, min: 39 },
    "dusseldorf-airport": { km: 238, min: 165 },
    "eindhoven-airport": { km: 129, min: 94 },
    "rotterdam": { km: 31, min: 35 },
    "rotterdam-centraal": { km: 30, min: 32 },
    "rotterdam-the-hague-airport": { km: 32, min: 28 },
    "schiphol": { km: 79, min: 60 },
    "utrecht": { km: 87, min: 71 },
    "utrecht-centraal": { km: 83, min: 65 },
  },
  "sliedrecht": {
    "amsterdam": { km: 86, min: 70 },
    "amsterdam-centraal": { km: 94, min: 71 },
    "brussels-airport": { km: 144, min: 104 },
    "den-haag": { km: 56, min: 50 },
    "den-haag-centraal": { km: 52, min: 45 },
    "dusseldorf-airport": { km: 195, min: 132 },
    "eindhoven-airport": { km: 91, min: 66 },
    "rotterdam": { km: 27, min: 32 },
    "rotterdam-centraal": { km: 34, min: 35 },
    "rotterdam-the-hague-airport": { km: 37, min: 30 },
    "schiphol": { km: 88, min: 65 },
    "utrecht": { km: 53, min: 45 },
    "utrecht-centraal": { km: 50, min: 41 },
  },
  "soest": {
    "amsterdam": { km: 44, min: 46 },
    "amsterdam-centraal": { km: 45, min: 46 },
    "brussels-airport": { km: 183, min: 133 },
    "den-haag": { km: 85, min: 69 },
    "den-haag-centraal": { km: 83, min: 64 },
    "dusseldorf-airport": { km: 196, min: 140 },
    "eindhoven-airport": { km: 129, min: 95 },
    "rotterdam": { km: 80, min: 68 },
    "rotterdam-centraal": { km: 79, min: 65 },
    "rotterdam-the-hague-airport": { km: 82, min: 60 },
    "schiphol": { km: 56, min: 46 },
    "utrecht": { km: 20, min: 29 },
    "utrecht-centraal": { km: 29, min: 32 },
  },
  "sommelsdijk": {
    "amsterdam": { km: 122, min: 95 },
    "amsterdam-centraal": { km: 119, min: 90 },
    "brussels-airport": { km: 135, min: 101 },
    "den-haag": { km: 70, min: 60 },
    "den-haag-centraal": { km: 65, min: 55 },
    "dusseldorf-airport": { km: 242, min: 168 },
    "eindhoven-airport": { km: 125, min: 93 },
    "rotterdam": { km: 54, min: 50 },
    "rotterdam-centraal": { km: 53, min: 47 },
    "rotterdam-the-hague-airport": { km: 54, min: 43 },
    "schiphol": { km: 102, min: 75 },
    "utrecht": { km: 110, min: 87 },
    "utrecht-centraal": { km: 106, min: 80 },
  },
  "spijkenisse": {
    "amsterdam": { km: 93, min: 75 },
    "amsterdam-centraal": { km: 90, min: 69 },
    "brussels-airport": { km: 154, min: 111 },
    "den-haag": { km: 40, min: 39 },
    "den-haag-centraal": { km: 36, min: 35 },
    "dusseldorf-airport": { km: 232, min: 160 },
    "eindhoven-airport": { km: 123, min: 89 },
    "rotterdam": { km: 25, min: 30 },
    "rotterdam-centraal": { km: 24, min: 28 },
    "rotterdam-the-hague-airport": { km: 25, min: 23 },
    "schiphol": { km: 73, min: 55 },
    "utrecht": { km: 81, min: 67 },
    "utrecht-centraal": { km: 77, min: 60 },
  },
  "stad-aan-t-haringvliet": {
    "amsterdam": { km: 127, min: 95 },
    "amsterdam-centraal": { km: 124, min: 89 },
    "brussels-airport": { km: 126, min: 91 },
    "den-haag": { km: 75, min: 59 },
    "den-haag-centraal": { km: 70, min: 54 },
    "dusseldorf-airport": { km: 234, min: 158 },
    "eindhoven-airport": { km: 117, min: 84 },
    "rotterdam": { km: 43, min: 46 },
    "rotterdam-centraal": { km: 44, min: 45 },
    "rotterdam-the-hague-airport": { km: 59, min: 42 },
    "schiphol": { km: 107, min: 74 },
    "utrecht": { km: 102, min: 77 },
    "utrecht-centraal": { km: 98, min: 70 },
  },
  "stellendam": {
    "amsterdam": { km: 109, min: 84 },
    "amsterdam-centraal": { km: 106, min: 78 },
    "brussels-airport": { km: 144, min: 107 },
    "den-haag": { km: 57, min: 48 },
    "den-haag-centraal": { km: 53, min: 43 },
    "dusseldorf-airport": { km: 252, min: 174 },
    "eindhoven-airport": { km: 135, min: 99 },
    "rotterdam": { km: 41, min: 38 },
    "rotterdam-centraal": { km: 40, min: 36 },
    "rotterdam-the-hague-airport": { km: 42, min: 31 },
    "schiphol": { km: 89, min: 63 },
    "utrecht": { km: 97, min: 75 },
    "utrecht-centraal": { km: 93, min: 68 },
  },
  "stolwijk": {
    "amsterdam": { km: 87, min: 72 },
    "amsterdam-centraal": { km: 68, min: 69 },
    "brussels-airport": { km: 164, min: 119 },
    "den-haag": { km: 40, min: 42 },
    "den-haag-centraal": { km: 38, min: 37 },
    "dusseldorf-airport": { km: 242, min: 160 },
    "eindhoven-airport": { km: 133, min: 97 },
    "rotterdam": { km: 32, min: 37 },
    "rotterdam-centraal": { km: 31, min: 35 },
    "rotterdam-the-hague-airport": { km: 33, min: 30 },
    "schiphol": { km: 51, min: 55 },
    "utrecht": { km: 55, min: 50 },
    "utrecht-centraal": { km: 51, min: 43 },
  },
  "streefkerk": {
    "amsterdam": { km: 86, min: 75 },
    "amsterdam-centraal": { km: 94, min: 77 },
    "brussels-airport": { km: 149, min: 110 },
    "den-haag": { km: 61, min: 55 },
    "den-haag-centraal": { km: 57, min: 50 },
    "dusseldorf-airport": { km: 208, min: 142 },
    "eindhoven-airport": { km: 105, min: 76 },
    "rotterdam": { km: 32, min: 38 },
    "rotterdam-centraal": { km: 39, min: 40 },
    "rotterdam-the-hague-airport": { km: 42, min: 35 },
    "schiphol": { km: 93, min: 71 },
    "utrecht": { km: 52, min: 51 },
    "utrecht-centraal": { km: 50, min: 47 },
  },
  "strijen": {
    "amsterdam": { km: 110, min: 87 },
    "amsterdam-centraal": { km: 107, min: 82 },
    "brussels-airport": { km: 130, min: 97 },
    "den-haag": { km: 57, min: 51 },
    "den-haag-centraal": { km: 53, min: 47 },
    "dusseldorf-airport": { km: 215, min: 150 },
    "eindhoven-airport": { km: 98, min: 75 },
    "rotterdam": { km: 26, min: 38 },
    "rotterdam-centraal": { km: 27, min: 38 },
    "rotterdam-the-hague-airport": { km: 42, min: 34 },
    "schiphol": { km: 90, min: 67 },
    "utrecht": { km: 84, min: 69 },
    "utrecht-centraal": { km: 80, min: 62 },
  },
  "strijensas": {
    "amsterdam": { km: 115, min: 92 },
    "amsterdam-centraal": { km: 112, min: 87 },
    "brussels-airport": { km: 130, min: 98 },
    "den-haag": { km: 65, min: 58 },
    "den-haag-centraal": { km: 61, min: 53 },
    "dusseldorf-airport": { km: 215, min: 151 },
    "eindhoven-airport": { km: 98, min: 77 },
    "rotterdam": { km: 36, min: 41 },
    "rotterdam-centraal": { km: 32, min: 43 },
    "rotterdam-the-hague-airport": { km: 46, min: 38 },
    "schiphol": { km: 95, min: 72 },
    "utrecht": { km: 88, min: 73 },
    "utrecht-centraal": { km: 84, min: 66 },
  },
  "ter-aar": {
    "amsterdam": { km: 42, min: 44 },
    "amsterdam-centraal": { km: 39, min: 38 },
    "brussels-airport": { km: 178, min: 127 },
    "den-haag": { km: 38, min: 40 },
    "den-haag-centraal": { km: 35, min: 35 },
    "dusseldorf-airport": { km: 236, min: 154 },
    "eindhoven-airport": { km: 147, min: 103 },
    "rotterdam": { km: 46, min: 45 },
    "rotterdam-centraal": { km: 45, min: 43 },
    "rotterdam-the-hague-airport": { km: 47, min: 37 },
    "schiphol": { km: 22, min: 24 },
    "utrecht": { km: 48, min: 45 },
    "utrecht-centraal": { km: 44, min: 38 },
  },
  "ter-heijde": {
    "amsterdam": { km: 79, min: 79 },
    "amsterdam-centraal": { km: 76, min: 73 },
    "brussels-airport": { km: 172, min: 126 },
    "den-haag": { km: 15, min: 31 },
    "den-haag-centraal": { km: 16, min: 34 },
    "dusseldorf-airport": { km: 252, min: 177 },
    "eindhoven-airport": { km: 142, min: 106 },
    "rotterdam": { km: 33, min: 39 },
    "rotterdam-centraal": { km: 32, min: 37 },
    "rotterdam-the-hague-airport": { km: 33, min: 32 },
    "schiphol": { km: 58, min: 58 },
    "utrecht": { km: 89, min: 76 },
    "utrecht-centraal": { km: 85, min: 69 },
  },
  "terneuzen": {
    "amsterdam": { km: 211, min: 145 },
    "amsterdam-centraal": { km: 208, min: 140 },
    "brussels-airport": { km: 97, min: 82 },
    "den-haag": { km: 159, min: 110 },
    "den-haag-centraal": { km: 154, min: 105 },
    "dusseldorf-airport": { km: 253, min: 179 },
    "eindhoven-airport": { km: 142, min: 110 },
    "rotterdam": { km: 127, min: 97 },
    "rotterdam-centraal": { km: 128, min: 96 },
    "rotterdam-the-hague-airport": { km: 144, min: 94 },
    "schiphol": { km: 191, min: 125 },
    "utrecht": { km: 179, min: 124 },
    "utrecht-centraal": { km: 177, min: 119 },
  },
  "tinte": {
    "amsterdam": { km: 98, min: 78 },
    "amsterdam-centraal": { km: 95, min: 73 },
    "brussels-airport": { km: 167, min: 119 },
    "den-haag": { km: 45, min: 42 },
    "den-haag-centraal": { km: 41, min: 38 },
    "dusseldorf-airport": { km: 245, min: 169 },
    "eindhoven-airport": { km: 136, min: 97 },
    "rotterdam": { km: 29, min: 32 },
    "rotterdam-centraal": { km: 28, min: 30 },
    "rotterdam-the-hague-airport": { km: 30, min: 26 },
    "schiphol": { km: 77, min: 58 },
    "utrecht": { km: 85, min: 69 },
    "utrecht-centraal": { km: 81, min: 62 },
  },
  "utrecht": {
    "amsterdam": { km: 49, min: 51 },
    "amsterdam-centraal": { km: 57, min: 53 },
    "brussels-airport": { km: 167, min: 125 },
    "den-haag": { km: 66, min: 59 },
    "den-haag-centraal": { km: 64, min: 54 },
    "dusseldorf-airport": { km: 199, min: 136 },
    "eindhoven-airport": { km: 113, min: 87 },
    "rotterdam": { km: 61, min: 57 },
    "rotterdam-centraal": { km: 60, min: 55 },
    "rotterdam-the-hague-airport": { km: 63, min: 50 },
    "schiphol": { km: 56, min: 49 },
    "utrecht-centraal": { km: 4, min: 12 },
  },
  "valkenburg": {
    "amsterdam": { km: 51, min: 45 },
    "amsterdam-centraal": { km: 48, min: 40 },
    "brussels-airport": { km: 182, min: 125 },
    "den-haag": { km: 16, min: 23 },
    "den-haag-centraal": { km: 16, min: 22 },
    "dusseldorf-airport": { km: 251, min: 163 },
    "eindhoven-airport": { km: 151, min: 103 },
    "rotterdam": { km: 38, min: 35 },
    "rotterdam-centraal": { km: 38, min: 32 },
    "rotterdam-the-hague-airport": { km: 33, min: 23 },
    "schiphol": { km: 31, min: 25 },
    "utrecht": { km: 63, min: 54 },
    "utrecht-centraal": { km: 59, min: 47 },
  },
  "veenendaal": {
    "amsterdam": { km: 78, min: 66 },
    "amsterdam-centraal": { km: 85, min: 68 },
    "brussels-airport": { km: 193, min: 138 },
    "den-haag": { km: 95, min: 74 },
    "den-haag-centraal": { km: 92, min: 69 },
    "dusseldorf-airport": { km: 165, min: 113 },
    "eindhoven-airport": { km: 107, min: 78 },
    "rotterdam": { km: 89, min: 72 },
    "rotterdam-centraal": { km: 89, min: 70 },
    "rotterdam-the-hague-airport": { km: 91, min: 65 },
    "schiphol": { km: 85, min: 64 },
    "utrecht": { km: 39, min: 39 },
    "utrecht-centraal": { km: 38, min: 37 },
  },
  "vierpolders": {
    "amsterdam": { km: 95, min: 75 },
    "amsterdam-centraal": { km: 92, min: 70 },
    "brussels-airport": { km: 164, min: 116 },
    "den-haag": { km: 42, min: 39 },
    "den-haag-centraal": { km: 38, min: 35 },
    "dusseldorf-airport": { km: 242, min: 166 },
    "eindhoven-airport": { km: 133, min: 95 },
    "rotterdam": { km: 26, min: 30 },
    "rotterdam-centraal": { km: 26, min: 27 },
    "rotterdam-the-hague-airport": { km: 27, min: 23 },
    "schiphol": { km: 75, min: 55 },
    "utrecht": { km: 83, min: 66 },
    "utrecht-centraal": { km: 79, min: 60 },
  },
  "vlaardingen": {
    "amsterdam": { km: 81, min: 65 },
    "amsterdam-centraal": { km: 78, min: 60 },
    "brussels-airport": { km: 150, min: 107 },
    "den-haag": { km: 28, min: 30 },
    "den-haag-centraal": { km: 24, min: 25 },
    "dusseldorf-airport": { km: 230, min: 158 },
    "eindhoven-airport": { km: 120, min: 87 },
    "rotterdam": { km: 12, min: 20 },
    "rotterdam-centraal": { km: 12, min: 18 },
    "rotterdam-the-hague-airport": { km: 13, min: 13 },
    "schiphol": { km: 61, min: 45 },
    "utrecht": { km: 69, min: 57 },
    "utrecht-centraal": { km: 65, min: 50 },
  },
  "vlissingen": {
    "amsterdam": { km: 176, min: 146 },
    "amsterdam-centraal": { km: 172, min: 141 },
    "brussels-airport": { km: 129, min: 96 },
    "den-haag": { km: 123, min: 110 },
    "den-haag-centraal": { km: 119, min: 106 },
    "dusseldorf-airport": { km: 277, min: 188 },
    "eindhoven-airport": { km: 161, min: 113 },
    "rotterdam": { km: 124, min: 98 },
    "rotterdam-centraal": { km: 125, min: 97 },
    "rotterdam-the-hague-airport": { km: 141, min: 95 },
    "schiphol": { km: 155, min: 126 },
    "utrecht": { km: 175, min: 125 },
    "utrecht-centraal": { km: 173, min: 121 },
  },
  "vlist": {
    "amsterdam": { km: 67, min: 66 },
    "amsterdam-centraal": { km: 75, min: 67 },
    "brussels-airport": { km: 168, min: 128 },
    "den-haag": { km: 44, min: 50 },
    "den-haag-centraal": { km: 42, min: 45 },
    "dusseldorf-airport": { km: 223, min: 155 },
    "eindhoven-airport": { km: 124, min: 95 },
    "rotterdam": { km: 35, min: 46 },
    "rotterdam-centraal": { km: 35, min: 43 },
    "rotterdam-the-hague-airport": { km: 37, min: 38 },
    "schiphol": { km: 53, min: 61 },
    "utrecht": { km: 35, min: 44 },
    "utrecht-centraal": { km: 31, min: 37 },
  },
  "volendam": {
    "amsterdam": { km: 22, min: 30 },
    "amsterdam-centraal": { km: 23, min: 31 },
    "brussels-airport": { km: 222, min: 158 },
    "den-haag": { km: 84, min: 69 },
    "den-haag-centraal": { km: 81, min: 64 },
    "dusseldorf-airport": { km: 248, min: 166 },
    "eindhoven-airport": { km: 168, min: 120 },
    "rotterdam": { km: 98, min: 77 },
    "rotterdam-centraal": { km: 97, min: 75 },
    "rotterdam-the-hague-airport": { km: 93, min: 66 },
    "schiphol": { km: 41, min: 39 },
    "utrecht": { km: 68, min: 59 },
    "utrecht-centraal": { km: 62, min: 53 },
  },
  "voorburg": {
    "amsterdam": { km: 62, min: 53 },
    "amsterdam-centraal": { km: 59, min: 47 },
    "brussels-airport": { km: 167, min: 116 },
    "den-haag": { km: 6, min: 15 },
    "den-haag-centraal": { km: 4, min: 9 },
    "dusseldorf-airport": { km: 250, min: 161 },
    "eindhoven-airport": { km: 136, min: 94 },
    "rotterdam": { km: 23, min: 25 },
    "rotterdam-centraal": { km: 22, min: 23 },
    "rotterdam-the-hague-airport": { km: 18, min: 14 },
    "schiphol": { km: 42, min: 33 },
    "utrecht": { km: 63, min: 51 },
    "utrecht-centraal": { km: 59, min: 44 },
  },
  "voorhout": {
    "amsterdam": { km: 45, min: 45 },
    "amsterdam-centraal": { km: 42, min: 39 },
    "brussels-airport": { km: 189, min: 131 },
    "den-haag": { km: 23, min: 30 },
    "den-haag-centraal": { km: 23, min: 29 },
    "dusseldorf-airport": { km: 258, min: 170 },
    "eindhoven-airport": { km: 157, min: 110 },
    "rotterdam": { km: 45, min: 41 },
    "rotterdam-centraal": { km: 44, min: 39 },
    "rotterdam-the-hague-airport": { km: 40, min: 30 },
    "schiphol": { km: 25, min: 24 },
    "utrecht": { km: 70, min: 60 },
    "utrecht-centraal": { km: 66, min: 53 },
  },
  "voorschoten": {
    "amsterdam": { km: 57, min: 52 },
    "amsterdam-centraal": { km: 54, min: 46 },
    "brussels-airport": { km: 175, min: 127 },
    "den-haag": { km: 13, min: 23 },
    "den-haag-centraal": { km: 13, min: 22 },
    "dusseldorf-airport": { km: 247, min: 167 },
    "eindhoven-airport": { km: 143, min: 106 },
    "rotterdam": { km: 31, min: 37 },
    "rotterdam-centraal": { km: 30, min: 35 },
    "rotterdam-the-hague-airport": { km: 26, min: 26 },
    "schiphol": { km: 37, min: 32 },
    "utrecht": { km: 60, min: 57 },
    "utrecht-centraal": { km: 56, min: 50 },
  },
  "vrouwenakker": {
    "amsterdam": { km: 33, min: 40 },
    "amsterdam-centraal": { km: 30, min: 34 },
    "brussels-airport": { km: 188, min: 137 },
    "den-haag": { km: 47, min: 46 },
    "den-haag-centraal": { km: 44, min: 41 },
    "dusseldorf-airport": { km: 234, min: 159 },
    "eindhoven-airport": { km: 144, min: 106 },
    "rotterdam": { km: 61, min: 54 },
    "rotterdam-centraal": { km: 60, min: 52 },
    "rotterdam-the-hague-airport": { km: 56, min: 43 },
    "schiphol": { km: 18, min: 22 },
    "utrecht": { km: 46, min: 49 },
    "utrecht-centraal": { km: 38, min: 40 },
  },
  "waal": {
    "amsterdam": { km: 75, min: 64 },
    "amsterdam-centraal": { km: 82, min: 65 },
    "brussels-airport": { km: 147, min: 107 },
    "den-haag": { km: 74, min: 68 },
    "den-haag-centraal": { km: 70, min: 63 },
    "dusseldorf-airport": { km: 196, min: 135 },
    "eindhoven-airport": { km: 93, min: 69 },
    "rotterdam": { km: 45, min: 50 },
    "rotterdam-centraal": { km: 52, min: 53 },
    "rotterdam-the-hague-airport": { km: 55, min: 48 },
    "schiphol": { km: 82, min: 61 },
    "utrecht": { km: 41, min: 39 },
    "utrecht-centraal": { km: 39, min: 35 },
  },
  "waarder": {
    "amsterdam": { km: 60, min: 51 },
    "amsterdam-centraal": { km: 68, min: 53 },
    "brussels-airport": { km: 169, min: 117 },
    "den-haag": { km: 41, min: 36 },
    "den-haag-centraal": { km: 39, min: 32 },
    "dusseldorf-airport": { km: 215, min: 139 },
    "eindhoven-airport": { km: 126, min: 88 },
    "rotterdam": { km: 36, min: 35 },
    "rotterdam-centraal": { km: 35, min: 33 },
    "rotterdam-the-hague-airport": { km: 38, min: 27 },
    "schiphol": { km: 42, min: 40 },
    "utrecht": { km: 28, min: 30 },
    "utrecht-centraal": { km: 24, min: 23 },
  },
  "waddinxveen": {
    "amsterdam": { km: 66, min: 62 },
    "amsterdam-centraal": { km: 63, min: 57 },
    "brussels-airport": { km: 157, min: 112 },
    "den-haag": { km: 28, min: 30 },
    "den-haag-centraal": { km: 25, min: 25 },
    "dusseldorf-airport": { km: 233, min: 153 },
    "eindhoven-airport": { km: 126, min: 91 },
    "rotterdam": { km: 25, min: 30 },
    "rotterdam-centraal": { km: 24, min: 28 },
    "rotterdam-the-hague-airport": { km: 26, min: 23 },
    "schiphol": { km: 46, min: 42 },
    "utrecht": { km: 45, min: 43 },
    "utrecht-centraal": { km: 41, min: 36 },
  },
  "warmond": {
    "amsterdam": { km: 49, min: 52 },
    "amsterdam-centraal": { km: 46, min: 47 },
    "brussels-airport": { km: 190, min: 136 },
    "den-haag": { km: 32, min: 37 },
    "den-haag-centraal": { km: 29, min: 32 },
    "dusseldorf-airport": { km: 253, min: 172 },
    "eindhoven-airport": { km: 158, min: 115 },
    "rotterdam": { km: 46, min: 46 },
    "rotterdam-centraal": { km: 45, min: 43 },
    "rotterdam-the-hague-airport": { km: 41, min: 34 },
    "schiphol": { km: 29, min: 32 },
    "utrecht": { km: 66, min: 62 },
    "utrecht-centraal": { km: 62, min: 55 },
  },
  "wassenaar": {
    "amsterdam": { km: 57, min: 58 },
    "amsterdam-centraal": { km: 54, min: 52 },
    "brussels-airport": { km: 178, min: 135 },
    "den-haag": { km: 12, min: 28 },
    "den-haag-centraal": { km: 12, min: 28 },
    "dusseldorf-airport": { km: 252, min: 174 },
    "eindhoven-airport": { km: 146, min: 113 },
    "rotterdam": { km: 34, min: 44 },
    "rotterdam-centraal": { km: 33, min: 42 },
    "rotterdam-the-hague-airport": { km: 29, min: 33 },
    "schiphol": { km: 36, min: 38 },
    "utrecht": { km: 65, min: 64 },
    "utrecht-centraal": { km: 61, min: 57 },
  },
  "wateringen": {
    "amsterdam": { km: 70, min: 64 },
    "amsterdam-centraal": { km: 67, min: 59 },
    "brussels-airport": { km: 162, min: 117 },
    "den-haag": { km: 17, min: 28 },
    "den-haag-centraal": { km: 13, min: 24 },
    "dusseldorf-airport": { km: 242, min: 168 },
    "eindhoven-airport": { km: 132, min: 97 },
    "rotterdam": { km: 23, min: 31 },
    "rotterdam-centraal": { km: 22, min: 28 },
    "rotterdam-the-hague-airport": { km: 18, min: 21 },
    "schiphol": { km: 49, min: 44 },
    "utrecht": { km: 71, min: 63 },
    "utrecht-centraal": { km: 66, min: 56 },
  },
  "westmaas": {
    "amsterdam": { km: 103, min: 78 },
    "amsterdam-centraal": { km: 100, min: 73 },
    "brussels-airport": { km: 126, min: 93 },
    "den-haag": { km: 50, min: 43 },
    "den-haag-centraal": { km: 46, min: 38 },
    "dusseldorf-airport": { km: 220, min: 154 },
    "eindhoven-airport": { km: 103, min: 79 },
    "rotterdam": { km: 18, min: 30 },
    "rotterdam-centraal": { km: 19, min: 29 },
    "rotterdam-the-hague-airport": { km: 34, min: 26 },
    "schiphol": { km: 82, min: 58 },
    "utrecht": { km: 77, min: 61 },
    "utrecht-centraal": { km: 73, min: 54 },
  },
  "wijngaarden": {
    "amsterdam": { km: 83, min: 69 },
    "amsterdam-centraal": { km: 90, min: 70 },
    "brussels-airport": { km: 144, min: 105 },
    "den-haag": { km: 57, min: 51 },
    "den-haag-centraal": { km: 52, min: 46 },
    "dusseldorf-airport": { km: 197, min: 135 },
    "eindhoven-airport": { km: 94, min: 69 },
    "rotterdam": { km: 27, min: 33 },
    "rotterdam-centraal": { km: 34, min: 36 },
    "rotterdam-the-hague-airport": { km: 37, min: 31 },
    "schiphol": { km: 90, min: 66 },
    "utrecht": { km: 49, min: 44 },
    "utrecht-centraal": { km: 47, min: 40 },
  },
  "woerden": {
    "amsterdam": { km: 42, min: 46 },
    "amsterdam-centraal": { km: 50, min: 48 },
    "brussels-airport": { km: 174, min: 124 },
    "den-haag": { km: 47, min: 43 },
    "den-haag-centraal": { km: 45, min: 38 },
    "dusseldorf-airport": { km: 213, min: 142 },
    "eindhoven-airport": { km: 124, min: 90 },
    "rotterdam": { km: 42, min: 42 },
    "rotterdam-centraal": { km: 41, min: 40 },
    "rotterdam-the-hague-airport": { km: 43, min: 34 },
    "schiphol": { km: 49, min: 44 },
    "utrecht": { km: 25, min: 32 },
    "utrecht-centraal": { km: 21, min: 25 },
  },
  "woerdense-verlaat": {
    "amsterdam": { km: 40, min: 42 },
    "amsterdam-centraal": { km: 47, min: 44 },
    "brussels-airport": { km: 183, min: 133 },
    "den-haag": { km: 55, min: 53 },
    "den-haag-centraal": { km: 53, min: 48 },
    "dusseldorf-airport": { km: 225, min: 149 },
    "eindhoven-airport": { km: 135, min: 97 },
    "rotterdam": { km: 50, min: 51 },
    "rotterdam-centraal": { km: 49, min: 49 },
    "rotterdam-the-hague-airport": { km: 52, min: 44 },
    "schiphol": { km: 34, min: 37 },
    "utrecht": { km: 37, min: 39 },
    "utrecht-centraal": { km: 29, min: 30 },
  },
  "woubrugge": {
    "amsterdam": { km: 43, min: 45 },
    "amsterdam-centraal": { km: 40, min: 39 },
    "brussels-airport": { km: 190, min: 133 },
    "den-haag": { km: 32, min: 34 },
    "den-haag-centraal": { km: 29, min: 29 },
    "dusseldorf-airport": { km: 239, min: 159 },
    "eindhoven-airport": { km: 150, min: 107 },
    "rotterdam": { km: 46, min: 43 },
    "rotterdam-centraal": { km: 45, min: 40 },
    "rotterdam-the-hague-airport": { km: 41, min: 31 },
    "schiphol": { km: 23, min: 25 },
    "utrecht": { km: 52, min: 49 },
    "utrecht-centraal": { km: 47, min: 42 },
  },
  "zaandam": {
    "amsterdam": { km: 16, min: 26 },
    "amsterdam-centraal": { km: 12, min: 20 },
    "brussels-airport": { km: 214, min: 151 },
    "den-haag": { km: 67, min: 56 },
    "den-haag-centraal": { km: 65, min: 51 },
    "dusseldorf-airport": { km: 242, min: 161 },
    "eindhoven-airport": { km: 160, min: 114 },
    "rotterdam": { km: 81, min: 64 },
    "rotterdam-centraal": { km: 81, min: 62 },
    "rotterdam-the-hague-airport": { km: 76, min: 53 },
    "schiphol": { km: 24, min: 26 },
    "utrecht": { km: 61, min: 54 },
    "utrecht-centraal": { km: 54, min: 47 },
  },
  "zeist": {
    "amsterdam": { km: 58, min: 52 },
    "amsterdam-centraal": { km: 59, min: 52 },
    "brussels-airport": { km: 172, min: 124 },
    "den-haag": { km: 74, min: 60 },
    "den-haag-centraal": { km: 72, min: 55 },
    "dusseldorf-airport": { km: 188, min: 126 },
    "eindhoven-airport": { km: 118, min: 86 },
    "rotterdam": { km: 69, min: 58 },
    "rotterdam-centraal": { km: 68, min: 56 },
    "rotterdam-the-hague-airport": { km: 71, min: 51 },
    "schiphol": { km: 64, min: 50 },
    "utrecht": { km: 9, min: 17 },
    "utrecht-centraal": { km: 14, min: 22 },
  },
  "zevenhoven": {
    "amsterdam": { km: 38, min: 44 },
    "amsterdam-centraal": { km: 35, min: 39 },
    "brussels-airport": { km: 185, min: 134 },
    "den-haag": { km: 48, min: 47 },
    "den-haag-centraal": { km: 45, min: 42 },
    "dusseldorf-airport": { km: 230, min: 155 },
    "eindhoven-airport": { km: 140, min: 103 },
    "rotterdam": { km: 52, min: 52 },
    "rotterdam-centraal": { km: 51, min: 50 },
    "rotterdam-the-hague-airport": { km: 57, min: 44 },
    "schiphol": { km: 24, min: 27 },
    "utrecht": { km: 43, min: 45 },
    "utrecht-centraal": { km: 35, min: 36 },
  },
  "zevenhuizen": {
    "amsterdam": { km: 80, min: 67 },
    "amsterdam-centraal": { km: 77, min: 61 },
    "brussels-airport": { km: 154, min: 111 },
    "den-haag": { km: 27, min: 31 },
    "den-haag-centraal": { km: 25, min: 26 },
    "dusseldorf-airport": { km: 236, min: 155 },
    "eindhoven-airport": { km: 122, min: 89 },
    "rotterdam": { km: 21, min: 29 },
    "rotterdam-centraal": { km: 20, min: 27 },
    "rotterdam-the-hague-airport": { km: 23, min: 21 },
    "schiphol": { km: 59, min: 46 },
    "utrecht": { km: 49, min: 45 },
    "utrecht-centraal": { km: 44, min: 38 },
  },
  "zierikzee": {
    "amsterdam": { km: 142, min: 113 },
    "amsterdam-centraal": { km: 139, min: 107 },
    "brussels-airport": { km: 133, min: 106 },
    "den-haag": { km: 89, min: 77 },
    "den-haag-centraal": { km: 85, min: 73 },
    "dusseldorf-airport": { km: 255, min: 177 },
    "eindhoven-airport": { km: 138, min: 102 },
    "rotterdam": { km: 64, min: 64 },
    "rotterdam-centraal": { km: 66, min: 63 },
    "rotterdam-the-hague-airport": { km: 74, min: 61 },
    "schiphol": { km: 122, min: 93 },
    "utrecht": { km: 123, min: 95 },
    "utrecht-centraal": { km: 119, min: 88 },
  },
  "zoetermeer": {
    "amsterdam": { km: 59, min: 58 },
    "amsterdam-centraal": { km: 56, min: 53 },
    "brussels-airport": { km: 162, min: 120 },
    "den-haag": { km: 16, min: 22 },
    "den-haag-centraal": { km: 14, min: 18 },
    "dusseldorf-airport": { km: 243, min: 160 },
    "eindhoven-airport": { km: 131, min: 99 },
    "rotterdam": { km: 30, min: 31 },
    "rotterdam-centraal": { km: 30, min: 29 },
    "rotterdam-the-hague-airport": { km: 25, min: 20 },
    "schiphol": { km: 39, min: 38 },
    "utrecht": { km: 55, min: 50 },
    "utrecht-centraal": { km: 51, min: 43 },
  },
  "zoeterwoude": {
    "amsterdam": { km: 51, min: 47 },
    "amsterdam-centraal": { km: 48, min: 41 },
    "brussels-airport": { km: 180, min: 125 },
    "den-haag": { km: 22, min: 26 },
    "den-haag-centraal": { km: 20, min: 21 },
    "dusseldorf-airport": { km: 241, min: 157 },
    "eindhoven-airport": { km: 148, min: 104 },
    "rotterdam": { km: 36, min: 35 },
    "rotterdam-centraal": { km: 35, min: 32 },
    "rotterdam-the-hague-airport": { km: 31, min: 24 },
    "schiphol": { km: 31, min: 27 },
    "utrecht": { km: 54, min: 47 },
    "utrecht-centraal": { km: 50, min: 40 },
  },
  "zuid-beijerland": {
    "amsterdam": { km: 115, min: 87 },
    "amsterdam-centraal": { km: 112, min: 82 },
    "brussels-airport": { km: 125, min: 90 },
    "den-haag": { km: 62, min: 52 },
    "den-haag-centraal": { km: 58, min: 47 },
    "dusseldorf-airport": { km: 232, min: 158 },
    "eindhoven-airport": { km: 115, min: 83 },
    "rotterdam": { km: 31, min: 39 },
    "rotterdam-centraal": { km: 32, min: 38 },
    "rotterdam-the-hague-airport": { km: 47, min: 35 },
    "schiphol": { km: 95, min: 67 },
    "utrecht": { km: 89, min: 70 },
    "utrecht-centraal": { km: 85, min: 63 },
  },
  "zuidland": {
    "amsterdam": { km: 102, min: 84 },
    "amsterdam-centraal": { km: 99, min: 78 },
    "brussels-airport": { km: 164, min: 119 },
    "den-haag": { km: 50, min: 48 },
    "den-haag-centraal": { km: 45, min: 43 },
    "dusseldorf-airport": { km: 241, min: 169 },
    "eindhoven-airport": { km: 132, min: 98 },
    "rotterdam": { km: 34, min: 38 },
    "rotterdam-centraal": { km: 33, min: 36 },
    "rotterdam-the-hague-airport": { km: 35, min: 32 },
    "schiphol": { km: 82, min: 63 },
    "utrecht": { km: 90, min: 75 },
    "utrecht-centraal": { km: 86, min: 68 },
  },
  "zwammerdam": {
    "amsterdam": { km: 52, min: 54 },
    "amsterdam-centraal": { km: 49, min: 49 },
    "brussels-airport": { km: 168, min: 119 },
    "den-haag": { km: 40, min: 38 },
    "den-haag-centraal": { km: 37, min: 33 },
    "dusseldorf-airport": { km: 225, min: 146 },
    "eindhoven-airport": { km: 136, min: 94 },
    "rotterdam": { km: 35, min: 37 },
    "rotterdam-centraal": { km: 34, min: 34 },
    "rotterdam-the-hague-airport": { km: 37, min: 29 },
    "schiphol": { km: 32, min: 34 },
    "utrecht": { km: 38, min: 36 },
    "utrecht-centraal": { km: 34, min: 29 },
  },
  "zwartewaal": {
    "amsterdam": { km: 95, min: 74 },
    "amsterdam-centraal": { km: 92, min: 69 },
    "brussels-airport": { km: 164, min: 115 },
    "den-haag": { km: 42, min: 38 },
    "den-haag-centraal": { km: 38, min: 34 },
    "dusseldorf-airport": { km: 242, min: 165 },
    "eindhoven-airport": { km: 133, min: 93 },
    "rotterdam": { km: 26, min: 28 },
    "rotterdam-centraal": { km: 26, min: 26 },
    "rotterdam-the-hague-airport": { km: 27, min: 22 },
    "schiphol": { km: 74, min: 54 },
    "utrecht": { km: 83, min: 65 },
    "utrecht-centraal": { km: 79, min: 58 },
  },
  "zwijndrecht": {
    "amsterdam": { km: 101, min: 81 },
    "amsterdam-centraal": { km: 98, min: 76 },
    "brussels-airport": { km: 126, min: 91 },
    "den-haag": { km: 49, min: 45 },
    "den-haag-centraal": { km: 44, min: 40 },
    "dusseldorf-airport": { km: 211, min: 144 },
    "eindhoven-airport": { km: 94, min: 70 },
    "rotterdam": { km: 20, min: 28 },
    "rotterdam-centraal": { km: 27, min: 31 },
    "rotterdam-the-hague-airport": { km: 29, min: 25 },
    "schiphol": { km: 81, min: 61 },
    "utrecht": { km: 67, min: 60 },
    "utrecht-centraal": { km: 68, min: 53 },
  },
};
